export const ACCOUNTING = {
  COMMON: {
    SELECT: {
      // Seleccionar tercero
      // Select third party
      TERCERO: 'ACCOUNTING.CAUSACION.SELECT.TERCERO',
    },
    BALANCE_SUMMARY: {
      LABEL: {
        DIFFERENCE_DEBIT_CREDIT: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.DIFFERENCE_DEBIT_CREDIT',
        TOTAL_CREDIT: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.TOTAL_CREDIT',
        TOTAL_DEBIT: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.TOTAL_DEBIT',
        BALANCED: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.BALANCED',
        NOT_BALANCED: 'ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL.NOT_BALANCED',
      },
    },
  },
  /**
   * Maestro de Clasificaciones de Asiento Contable (HT_CON_008 V4, Alcance 3).
   *
   * Catalogo FIJO que administra solo el administrador: nace con dieciseis clasificaciones y se
   * amplia por el CRUD. Ninguna se elimina —una clasificacion que deja de usarse se INACTIVA—,
   * de modo que el maestro no declara claves de borrado.
   */
  JOURNAL_CLASSIFICATION: {
    TITLE: {
      LIST: 'ACCOUNTING.JOURNAL_CLASSIFICATION.TITLE.LIST',
      CREATE: 'ACCOUNTING.JOURNAL_CLASSIFICATION.TITLE.CREATE',
      EDIT: 'ACCOUNTING.JOURNAL_CLASSIFICATION.TITLE.EDIT',
      VIEW: 'ACCOUNTING.JOURNAL_CLASSIFICATION.TITLE.VIEW',
    },
    SUBTITLE: {
      LIST: 'ACCOUNTING.JOURNAL_CLASSIFICATION.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.JOURNAL_CLASSIFICATION.SUBTITLE.CREATE',
      EDIT: 'ACCOUNTING.JOURNAL_CLASSIFICATION.SUBTITLE.EDIT',
      VIEW: 'ACCOUNTING.JOURNAL_CLASSIFICATION.SUBTITLE.VIEW',
    },
    COLUMNS: {
      CODE: 'ACCOUNTING.JOURNAL_CLASSIFICATION.COLUMNS.CODE',
      NAME: 'ACCOUNTING.JOURNAL_CLASSIFICATION.COLUMNS.NAME',
      STATUS: 'ACCOUNTING.JOURNAL_CLASSIFICATION.COLUMNS.STATUS',
      /** Si la clasificacion ya esta tomada por un concepto: gobierna que puede editarse. */
      LINKED: 'ACCOUNTING.JOURNAL_CLASSIFICATION.COLUMNS.LINKED',
      LINKED_CONCEPT: 'ACCOUNTING.JOURNAL_CLASSIFICATION.COLUMNS.LINKED_CONCEPT',
    },
    FORM: {
      SECTION: {
        IDENTIFICATION: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.SECTION.IDENTIFICATION',
      },
      PANEL: {
        SUMMARY: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.PANEL.SUMMARY',
        SUMMARY_TITLE_EMPTY: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.PANEL.SUMMARY_TITLE_EMPTY',
        SUMMARY_CODE_EMPTY: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.PANEL.SUMMARY_CODE_EMPTY',
        CHECKLIST: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.PANEL.CHECKLIST',
        USAGE: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.PANEL.USAGE',
        USAGE_HINT: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.PANEL.USAGE_HINT',
      },
      CODE_HINT: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.CODE_HINT',
      NAME_HINT: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.NAME_HINT',
      STATUS_HINT: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.STATUS_HINT',
      TOOLTIP: {
        CODE: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.TOOLTIP.CODE',
        NAME: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.TOOLTIP.NAME',
        STATUS: 'ACCOUNTING.JOURNAL_CLASSIFICATION.FORM.TOOLTIP.STATUS',
      },
    },
    COUNTER: {
      SINGULAR: 'ACCOUNTING.JOURNAL_CLASSIFICATION.COUNTER.SINGULAR',
      PLURAL: 'ACCOUNTING.JOURNAL_CLASSIFICATION.COUNTER.PLURAL',
    },
    SEARCH_PLACEHOLDER: 'ACCOUNTING.JOURNAL_CLASSIFICATION.SEARCH_PLACEHOLDER',
    EMPTY: {
      MESSAGE: 'ACCOUNTING.JOURNAL_CLASSIFICATION.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.JOURNAL_CLASSIFICATION.EMPTY.DESCRIPTION',
    },
    RESULT: {
      CREATED: 'ACCOUNTING.JOURNAL_CLASSIFICATION.RESULT.CREATED',
      CREATE_ERROR: 'ACCOUNTING.JOURNAL_CLASSIFICATION.RESULT.CREATE_ERROR',
      UPDATED: 'ACCOUNTING.JOURNAL_CLASSIFICATION.RESULT.UPDATED',
      UPDATE_ERROR: 'ACCOUNTING.JOURNAL_CLASSIFICATION.RESULT.UPDATE_ERROR',
    },
    /** Advertencia de parecido (RN-ALC3-11): advierte y pide confirmacion, no bloquea. */
    SIMILARITY: {
      TITLE: 'ACCOUNTING.JOURNAL_CLASSIFICATION.SIMILARITY.TITLE',
      CONFIRM: 'ACCOUNTING.JOURNAL_CLASSIFICATION.SIMILARITY.CONFIRM',
      CANCEL: 'ACCOUNTING.JOURNAL_CLASSIFICATION.SIMILARITY.CANCEL',
    },
  },

  /**
   * Maestro de Conceptos Contables (HT_CON_008 V4, Alcance 1).
   *
   * Las tres primeras columnas NO estrenan clave: el codigo, el nombre y el estado se nombran
   * igual en toda la aplicacion y se resuelven por donde ya estaban.
   */
  CONCEPT: {
    TITLE: {
      LIST: 'ACCOUNTING.CONCEPT.TITLE.LIST',
      CREATE: 'ACCOUNTING.CONCEPT.TITLE.CREATE',
      EDIT: 'ACCOUNTING.CONCEPT.TITLE.EDIT',
      VIEW: 'ACCOUNTING.CONCEPT.TITLE.VIEW',
    },
    COLUMNS: {
      CODE: 'LABELS.CODE',
      NAME: 'LABELS.NAME',
      STATUS: 'COMMON.STATUS',
      /** La clasificacion de la que cuelga el concepto (RN-ALC1-02). */
      CLASSIFICATION: 'ACCOUNTING.CONCEPT.COLUMNS.CLASSIFICATION',
      /**
       * Titulo de la columna de advertencias del listado (RN-ALC2-06).
       *
       * La CELDA no se traduce aqui: el servidor manda la marca ya resuelta y en blanco cuando
       * no hay nada que advertir. Esta clave nombra la columna, no su contenido.
       */
      WARNING: 'ACCOUNTING.CONCEPT.COLUMNS.WARNING',
    },
    FORM: {
      SECTION: {
        IDENTIFICATION: 'ACCOUNTING.CONCEPT.FORM.SECTION.IDENTIFICATION',
      },
      PANEL: {
        SUMMARY: 'ACCOUNTING.CONCEPT.FORM.PANEL.SUMMARY',
        SUMMARY_TITLE_EMPTY: 'ACCOUNTING.CONCEPT.FORM.PANEL.SUMMARY_TITLE_EMPTY',
        SUMMARY_CODE_EMPTY: 'ACCOUNTING.CONCEPT.FORM.PANEL.SUMMARY_CODE_EMPTY',
        CHECKLIST: 'ACCOUNTING.CONCEPT.FORM.PANEL.CHECKLIST',
        USAGE: 'ACCOUNTING.CONCEPT.FORM.PANEL.USAGE',
        USAGE_HINT: 'ACCOUNTING.CONCEPT.FORM.PANEL.USAGE_HINT',
      },
      CODE_TOOLTIP: 'ACCOUNTING.CONCEPT.FORM.CODE_TOOLTIP',
      NAME_TOOLTIP: 'ACCOUNTING.CONCEPT.FORM.NAME_TOOLTIP',
      STATUS_TOOLTIP: 'ACCOUNTING.CONCEPT.FORM.STATUS_TOOLTIP',
      CLASSIFICATION_LABEL: 'ACCOUNTING.CONCEPT.FORM.CLASSIFICATION_LABEL',
      CLASSIFICATION_PLACEHOLDER: 'ACCOUNTING.CONCEPT.FORM.CLASSIFICATION_PLACEHOLDER',
      CLASSIFICATION_TOOLTIP: 'ACCOUNTING.CONCEPT.FORM.CLASSIFICATION_TOOLTIP',
    },
  },

  /**
   * Maestro de Tipos de Asiento Contable (HT_CON_008 V4, Alcance 2).
   *
   * Las tres primeras columnas NO estrenan clave: el codigo, el nombre y el estado se nombran
   * igual en toda la aplicacion y se resuelven por donde ya estaban.
   */
  JOURNAL_ENTRY_TYPE: {
    COLUMNS: {
      CODE: 'COLUMNS.CODE', // Codigo / Code; la de Anulacion dice «Reason for cancellation» (Mantis #390)
      NAME: 'ACCOUNTING.CITY.FORM.NAME',
      STATUS: 'COMMON.STATUS',
      /** El concepto del que cuelga el tipo (Mantis #318). */
      CONCEPT: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.COLUMNS.CONCEPT',
      /** Si el tipo es el de anulacion del concepto (RN-ALC2-05). */
      ANNULMENT: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.OPTIONS.CLASSIFICATION.CANCELLATION',
    },
    FORM: {
      SECTION: {
        IDENTIFICATION: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.SECTION.IDENTIFICATION',
        MARK: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.SECTION.MARK',
      },
      PANEL: {
        SUMMARY: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.PANEL.SUMMARY',
        SUMMARY_TITLE_EMPTY: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.PANEL.SUMMARY_TITLE_EMPTY',
        SUMMARY_CODE_EMPTY: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.PANEL.SUMMARY_CODE_EMPTY',
        CHECKLIST: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.PANEL.CHECKLIST',
        USAGE: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.PANEL.USAGE',
        USAGE_HINT: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.PANEL.USAGE_HINT',
      },
      HINT: {
        ANNULMENT: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.HINT.ANNULMENT',
      },
      CODE_TOOLTIP: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.CODE_TOOLTIP',
      NAME_TOOLTIP: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.NAME_TOOLTIP',
      STATUS_TOOLTIP: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.STATUS_TOOLTIP',
      CONCEPT_LABEL: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.CONCEPT_LABEL',
      CONCEPT_PLACEHOLDER: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.CONCEPT_PLACEHOLDER',
      /** Lo que dice el cuadro de la DESCRIPCION, pegado al codigo del concepto. */
      CONCEPT_NAME_PLACEHOLDER: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.CONCEPT_NAME_PLACEHOLDER',
      CONCEPT_TOOLTIP: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.CONCEPT_TOOLTIP',
      CONCEPT_ACTION_TOOLTIP: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.CONCEPT_ACTION_TOOLTIP',
      ANNULMENT_LABEL: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.OPTIONS.CLASSIFICATION.CANCELLATION',
      ANNULMENT_TOOLTIP: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.FORM.ANNULMENT_TOOLTIP',
    },
    MODAL: {
      SELECT_CONCEPT: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.MODAL.SELECT_CONCEPT',
    },
    /** Lo que impide editar o eliminar un tipo, y el fallo del buscador de conceptos. */
    ERROR: {
      CANNOT_EDIT_ASSOCIATED: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.ERROR.CANNOT_EDIT_ASSOCIATED',
      CANNOT_DELETE_ACTIVE: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.ERROR.CANNOT_DELETE_ACTIVE',
      CANNOT_DELETE_ASSOCIATED: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.ERROR.CANNOT_DELETE_ASSOCIATED',
      CONCEPT_SEARCH: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.ERROR.CONCEPT_SEARCH',
    },
    VALIDATION: {
      CONCEPT_REQUIRED: 'ACCOUNTING.JOURNAL_ENTRY_TYPE.VALIDATION.CONCEPT_REQUIRED',
    },
  },

  /**
   * Plan de Cuentas Contables.
   *
   * <p>Las claves de campo ya existian y NO se duplican: la pantalla las venia usando sueltas en
   * su plantilla y aqui solo quedan nombradas. Lo que estrena son los rotulos de las cuatro
   * pestañas, los titulos de las tarjetas nuevas y las notas que explican cada marca.</p>
   */
  CHART_OF_ACCOUNTS: {
    /** Fallos de las consultas de apoyo del plan. */
    ERROR: {
      PLAN_TYPES_LOAD: 'ACCOUNTING.CHART_OF_ACCOUNTS.ERROR.PLAN_TYPES_LOAD',
      SYSTEM_PARAMETERS_LOAD: 'ACCOUNTING.CHART_OF_ACCOUNTS.ERROR.SYSTEM_PARAMETERS_LOAD',
    },
    TABS: {
      GENERAL: 'ACCOUNTING.CHART_OF_ACCOUNTS.TABS.GENERAL',
      CHARACTERISTICS: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.CHARACTERISTICS_TITLE',
      CLOSING: 'ACCOUNTING.CHART_OF_ACCOUNTS.TABS.CLOSING',
      HOMOLOGATION: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HOMOLOGATION_TITLE',
      SUBACCOUNTS: 'ACCOUNTING.CHART_OF_ACCOUNTS.TABS.SUBACCOUNTS',
    },
    SECTION: {
      /** Donde cuelga la cuenta: plan, padre y codigo. */
      LOCATION: 'ACCOUNTING.CHART_OF_ACCOUNTS.SECTION.LOCATION',
      GENERAL: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.GENERAL_DATA_TITLE',
      /** Lo que el sistema exigira al registrar comprobantes sobre la cuenta. */
      CONTROLS: 'ACCOUNTING.CHART_OF_ACCOUNTS.SECTION.CONTROLS',
      DEDUCTION: 'ACCOUNTING.CHART_OF_ACCOUNTS.SECTION.DEDUCTION',
      CLOSING: 'ACCOUNTING.CHART_OF_ACCOUNTS.SECTION.CLOSING',
      DIAN: 'ACCOUNTING.CHART_OF_ACCOUNTS.SECTION.DIAN',
      HOMOLOGATION: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HOMOLOGATION_TITLE',
    },
    FORM: {
      PLAN_TYPE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLAN_TYPE_LABEL',
      PARENT_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PARENT_ACCOUNT',
      /** Lo que dice el cuadro de la DESCRIPCION, pegado al codigo del padre. */
      PARENT_NAME: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PARENT_NAME',
      CODE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.CODE',
      NAME: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.NAME',
      LEVEL: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.LEVEL',
      NATURE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.NATURE',
      OPERATION_TYPE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.OPERATION_TYPE',
      MOVEMENT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.MOVEMENT',
      STATUS: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.STATUS',
      REQUIRES_THIRD_PARTY: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.REQUIRES_THIRD_PARTY',
      REQUIRES_COST_CENTER: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.REQUIRES_COST_CENTER',
      IS_DEFERRED: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.IS_DEFERRED',
      IS_PAYABLE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.IS_PAYABLE',
      IS_RECEIVABLE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.IS_RECEIVABLE',
      IS_ADVANCE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.IS_ADVANCE',
      IS_TAX_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.IS_TAX_ACCOUNT',
      DEDUCTION_TYPE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.DEDUCTION_TYPE',
      WITHHOLDING_BASE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.WITHHOLDING_BASE',
      WITHHOLDING_PERCENTAGE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.WITHHOLDING_PERCENTAGE',
      THIRD_PARTY_DEDUCTION: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.THIRD_PARTY_DEDUCTION_PAYMENT',
      CITY: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.CITY',
      DEDUCTION_ACCOUNT_CODE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.DEDUCTION_ACCOUNT_CODE',
      CLOSING_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.CLOSING_ACCOUNT',
      CLOSING_PERIOD_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.CLOSING_PERIOD_ACCOUNT',
      INCOME_STATEMENT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.INCOME_STATEMENT_RESULT',
      CERTIFICATE_220: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.CERTIFICATE_220_ACCOUNT',
      DIAN_CONCEPT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.DIAN_CONCEPT',
      ENABLE_HOMOLOGATION: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.ENABLE_HOMOLOGATION',
      /** La nota que dice QUE CAMBIA al poner cada marca. El rotulo solo la nombra. */
      HINT: {
        REQUIRES_THIRD_PARTY: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.REQUIRES_THIRD_PARTY',
        REQUIRES_COST_CENTER: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.REQUIRES_COST_CENTER',
        IS_DEFERRED: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.IS_DEFERRED',
        IS_PAYABLE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.IS_PAYABLE',
        IS_RECEIVABLE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.IS_RECEIVABLE',
        IS_ADVANCE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.IS_ADVANCE',
        IS_TAX_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.IS_TAX_ACCOUNT',
        CLOSING_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.CLOSING_ACCOUNT',
        CLOSING_PERIOD_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.CLOSING_PERIOD_ACCOUNT',
        CERTIFICATE_220: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.CERTIFICATE_220',
        ENABLE_HOMOLOGATION: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.HINT.ENABLE_HOMOLOGATION',
      },
      PANEL: {
        SUMMARY: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PANEL.SUMMARY',
        SUMMARY_TITLE_EMPTY: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PANEL.SUMMARY_TITLE_EMPTY',
        SUMMARY_CODE_EMPTY: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PANEL.SUMMARY_CODE_EMPTY',
        CHECKLIST: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PANEL.CHECKLIST',
        USAGE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PANEL.USAGE',
        USAGE_HINT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PANEL.USAGE_HINT',
      },
      TOOLTIP: {
        PLAN_TYPE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.PLAN_TYPE_SELECTED',
        PARENT_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.PARENT_ACCOUNT',
        CODE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.CODE',
        NAME: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.NAME',
        LEVEL: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.LEVEL',
        NATURE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.NATURE',
        OPERATION_TYPE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.OPERATION_TYPE',
        MOVEMENT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.MOVEMENT',
        STATUS: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.STATUS',
        DEDUCTION_TYPE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.DEDUCTION_TYPE',
        REQUIRES_THIRD_PARTY: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.REQUIRES_THIRD_PARTY',
        REQUIRES_COST_CENTER: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.REQUIRES_COST_CENTER',
        IS_DEFERRED: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.IS_DEFERRED',
        IS_PAYABLE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.IS_PAYABLE',
        IS_RECEIVABLE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.IS_RECEIVABLE',
        IS_ADVANCE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.IS_ADVANCE',
        IS_TAX_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.IS_TAX_ACCOUNT',
        WITHHOLDING_BASE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.WITHHOLDING_BASE',
        WITHHOLDING_PERCENTAGE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.WITHHOLDING_PERCENTAGE',
        CLOSING_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.CLOSING_ACCOUNT',
        CLOSING_PERIOD_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.CLOSING_PERIOD_ACCOUNT',
        INCOME_STATEMENT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.INCOME_STATEMENT',
        CERTIFICATE_220: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.CERTIFICATE_220',
        THIRD_PARTY_DEDUCTION: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.THIRD_PARTY_DEDUCTION',
        CITY: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.CITY',
        DEDUCTION_ACCOUNT_CODE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.DEDUCTION_ACCOUNT_CODE',
        DIAN_CONCEPT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.TOOLTIP.DIAN_CONCEPT',
      },
      PLACEHOLDER: {
        PLAN_TYPE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.PLAN_TYPE',
        PARENT_ACCOUNT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.PARENT_ACCOUNT',
        CODE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.CODE',
        NAME: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.NAME',
        LEVEL: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.LEVEL',
        NATURE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.NATURE',
        OPERATION_TYPE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.OPERATION_TYPE',
        MOVEMENT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.MOVEMENT',
        STATUS: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.STATUS',
        DEDUCTION_TYPE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.DEDUCTION_TYPE',
        WITHHOLDING_BASE: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.WITHHOLDING_BASE',
        WITHHOLDING_PERCENTAGE:
          'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.WITHHOLDING_PERCENTAGE',
        THIRD_PARTY_DEDUCTION:
          'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.THIRD_PARTY_DEDUCTION_PAYMENT',
        CITY: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.CITY',
        DEDUCTION_ACCOUNT_CODE:
          'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.DEDUCTION_ACCOUNT_CODE',
        INCOME_STATEMENT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.INCOME_STATEMENT_RESULT',
        DIAN_CONCEPT: 'ACCOUNTING.CHART_OF_ACCOUNTS.FORM.PLACEHOLDER.DIAN_CONCEPT',
      },
    },
  },

  ACCOUNTING_CONCEPTS: {
    COUNTER: {
      // concepto
      LABEL_SINGULAR: 'ACCOUNTING.ACCOUNTING_CONCEPTS.COUNTER.LABEL_SINGULAR',

      // conceptos
      LABEL_PLURAL: 'ACCOUNTING.ACCOUNTING_CONCEPTS.COUNTER.LABEL_PLURAL',
    },

    PLACEHOLDER: {
      // Buscar por código o nombre
      // Search by code or name
      SEARCH: 'ACCOUNTING.ACCOUNTING_CONCEPTS.PLACEHOLDER.SEARCH',
      //Seleccione un tipo de asiento
      JOURNAL_ENTRY_TYPE: 'ACCOUNTING.ACCOUNTING_CONCEPTS.PLACEHOLDER.JOURNAL_ENTRY_TYPE',
    },

    EMPTY: {
      //No se encontraron conceptos contables
      MESSAGE: 'ACCOUNTING.CAUSACION.EMPTY.MESSAGE',

      // Intenta con otro término de búsqueda o limpia los filtros.
      DESCRIPTION: 'ACCOUNTING.CAUSACION.EMPTY.DESCRIPTION',
    },

    LABEL: {
      //tipos de asiento
      JOURNAL_ENTRY_TYPE: 'ACCOUNTING.CAUSACION.LABEL.JOURNAL_ENTRY_TYPE',

      // CODIGOr
      CODE: 'ACCOUNTING.CAUSACION.LABEL.CODE', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // Nombre
      NAME: 'ACCOUNTING.CAUSACION.LABEL.NAME', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // ESTADO
      STATUS: 'ACCOUNTING.CAUSACION.LABEL.STATUS', // TO DO: SI ESTA EN BD CAMBIA LA KEY
    },

    TOOLTIP: {
      //tipos de asiento
      JOURNAL_ENTRY_TYPE: 'ACCOUNTING.CAUSACION.TOOLTIP.JOURNAL_ENTRY_TYPE',

      // Código del concepto contable
      CODE: 'ACCOUNTING.CAUSACION.TOOLTIP.CODE',

      // Nombre del concepto contable
      NAME: 'ACCOUNTING.CAUSACION.TOOLTIP.NAME',
      STATUS: 'ACCOUNTING.CAUSACION.TOOLTIP.STATUS',
    },

    OPTION: {
      // Sí
      // Yes
      SI: 'ACCOUNTING.CAUSACION.OPTION.SI', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // No
      // No
      NO: 'ACCOUNTING.CAUSACION.OPTION.NO', // TO DO: SI ESTA EN BD CAMBIA LA KEY
    },

    COLUMNS_NAMES: {
      // CODIGOr
      CODE: 'ACCOUNTING.CAUSACION.LABEL.CODE', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // Nombre
      NAME: 'ACCOUNTING.CAUSACION.LABEL.NAME', // TO DO: SI ESTA EN BD CAMBIA LA KEY

      // ESTADO
      STATUS: 'ACCOUNTING.CAUSACION.LABEL.STATUS', // TO DO: SI ESTA EN BD CAMBIA LA KEY
    },
    MESSAGES: {
      WARNING: {
        SELECCIONAR_TERCERO: 'ACCOUNTING.CAUSACION.WARNING.SELECCIONAR_TERCERO',
      },
      SUCCESS: {
        // Tercero encontrado
        // Third party found
        THIRD_PARTY_FOUND: 'ACCOUNTING.CAUSACION.MESSAGE.THIRD_PARTY_FOUND',
        THIRD_PARTY_NAME: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.THIRD_PARTY',
        THIRD_PARTY_NO_IDENTIFICATION:
          'ACCOUNTING.CAUSACION.COLUMNS_NAMES.THIRD_PARTY_NO_IDENTIFICATION',
        // Tercero seleccionado
        // Third party selected
        TERCERO_SELECCIONADO: 'ACCOUNTING.CAUSACION.MESSAGES.TERCERO_SELECCIONADO',
        // Asiento importado exitosamente. Total Débito: {0}, Total Crédito: {1}
        // Entry imported successfully. Total Debit: {0}, Total Credit: {1}
        ASIENTO_IMPORTADO: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.ASIENTO_IMPORTADO',

        // Deducción aplicada exitosamente. {0}% - {1}
        // Deduction applied successfully. {0}% - {1}
        DEDUCCION_APLICADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DEDUCCION_APLICADA',

        // Plantilla exportada exitosamente en formato {0}
        // Template exported successfully in {0} format
        PLANTILLA_EXPORTADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.PLANTILLA_EXPORTADA',

        // Deducción actualizada exitosamente
        // Deduction updated successfully
        DEDUCCION_ACTUALIZADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DEDUCCION_ACTUALIZADA',

        // Diferido aplicado correctamente. {0}: {1}
        // Deferred applied successfully. {0}: {1}
        DIFERIDO_APLICADO: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DIFERIDO_APLICADO',
      },
      ERRORS: {
        // Errores de fecha expedición
        FECHA_EXPEDICION_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_EXPEDICION_REQUIRED',
        FECHA_FUTURA: 'ACCOUNTING.CAUSACION.ERROR.FECHA_FUTURA',

        // Errores de fecha vencimiento
        FECHA_VENCIMIENTO_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_VENCIMIENTO_REQUIRED',
        FECHA_VENC_MENOR_EXPEDICION: 'ACCOUNTING.CAUSACION.ERROR.FECHA_VENC_MENOR_EXPEDICION',

        // Errores de fecha radicación
        FECHA_RADICACION_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RADICACION_REQUIRED',
        FECHA_RAD_FUTURA: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RAD_FUTURA',
        FECHA_RAD_MENOR_EXPEDICION: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RAD_MENOR_EXPEDICION',

        // Tercero no encontrado El No. Identificación no existe o no está activo. Abriendo selector
        // Third party not found
        THIRD_PARTY_NOT_FOUND: 'ACCOUNTING.CAUSACION.MESSAGE.THIRD_PARTY_NOT_FOUND',
        // Tercero no existe o está inactivo
        // Third party does not exist or is inactive
        TERCERO_NO_EXISTE_O_INACTIVO: 'ACCOUNTING.CAUSACION.MESSAGES.TERCERO_NO_EXISTE_O_INACTIVO',

        // Error al validar tercero
        // Error validating third party
        ERROR_VALIDAR_TERCERO: 'ACCOUNTING.CAUSACION.MESSAGES.ERROR_VALIDAR_TERCERO',
        // Error al buscar terceros
        // Error searching third parties
        ERROR_BUSCAR_TERCEROS: 'ACCOUNTING.CAUSACION.MESSAGES.ERROR_BUSCAR_TERCEROS',

        // Error al cargar información adicional del asiento
        // Error loading additional entry information
        ERROR_CARGAR_ASIENTO: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_CARGAR_ASIENTO',

        // Error al obtener cuentas contables
        // Error retrieving chart of accounts
        ERROR_OBTENER_CUENTAS: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_OBTENER_CUENTAS',

        // Error al obtener terceros
        // Error retrieving third parties
        ERROR_OBTENER_TERCEROS: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_OBTENER_TERCEROS',

        // Error al exportar la plantilla
        // Error exporting template
        ERROR_EXPORTAR_PLANTILLA: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_EXPORTAR_PLANTILLA',

        // No se encontró la línea de asiento para actualizar
        // Entry line not found for update
        LINEA_ASIENTO_NO_ENCONTRADA:
          'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.LINEA_ASIENTO_NO_ENCONTRADA',
      },
      WARNINGS: {
        // Cuentas contables no encontradas: {0}
        // Chart of accounts not found: {0}
        CUENTAS_NO_ENCONTRADAS: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.CUENTAS_NO_ENCONTRADAS',

        // No hay datos para exportar
        // No data to export
        NO_HAY_DATOS_EXPORTAR: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.NO_HAY_DATOS_EXPORTAR',

        // No hay deducción para editar
        // No deduction available to edit
        NO_HAY_DEDUCCION: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.NO_HAY_DEDUCCION',

        //Solo se pueden editar documentos en estado RECHAZADO
        //Solo se pueden eliminar documentos en estado RECHAZADO
        EDITAR_SOLO_RECHAZADO: 'ACCOUNTING.CAUSACION.ERROR.EDITAR_SOLO_RECHAZADO',
        ELIMINAR_SOLO_RECHAZADO: 'ACCOUNTING.CAUSACION.ERROR.ELIMINAR_SOLO_RECHAZADO',
      },

      HINTS: {
        // Debe ingresar al menos {0} caracteres
        // Enter at least {0} characters
        MINIMO_CARACTERES: 'ACCOUNTING.CAUSACION.MESSAGES.HINTS.MINIMO_CARACTERES',
      },
    },
  },
  CAUSACION: {
    MODAL: {
      SELECT_ARTICLE: 'ACCOUNTING.CAUSACION.MODAL.SELECT_ARTICLE',
    },
    COUNTER: {
      // Documento
      // Document
      LABEL_SINGULAR: 'ACCOUNTING.CAUSACION.COUNTER.LABEL_SINGULAR',

      // Documentos
      // Documents
      LABEL_PLURAL: 'ACCOUNTING.CAUSACION.COUNTER.LABEL_PLURAL',
    },

    PLACEHOLDER: {
      // Buscar por No. documento, identificación, tercero o estado
      // Search by document number, identification, third party or status
      SEARCH: 'ACCOUNTING.CAUSACION.PLACEHOLDER.SEARCH.message',

      // Buscar por consecutivo o tercero
      // Search by consecutive number or third party
      SEARCH_ORDEN_PAGO: 'ACCOUNTING.CAUSACION.PLACEHOLDER.SEARCH.ORDEN_PAGO',

      // dd/MM/yyyy
      // dd/MM/yyyy
      DATE: 'ACCOUNTING.CAUSACION.PLACEHOLDER.DATE',

      // Seleccione una fecha de expedición
      // Select an issue date
      FECHA_EXPEDICION: 'ACCOUNTING.CAUSACION.PLACEHOLDER.FECHA_EXPEDICION',

      // Seleccione una fecha de vencimiento
      // Select a due date
      FECHA_VENCIMIENTO: 'ACCOUNTING.CAUSACION.PLACEHOLDER.FECHA_VENCIMIENTO',

      // Seleccione una fecha de radicación
      // Select a filing date
      FECHA_RADICACION: 'ACCOUNTING.CAUSACION.PLACEHOLDER.FECHA_RADICACION',
      //Selecione genera OP
      //  Select generates payment order
      GENERA_OP: 'ACCOUNTING.CAUSACION.PLACEHOLDER.GENERA_OP',
      // Descripción
      // Description
      DESCRIPCION: 'ACCOUNTING.CAUSACION.PLACEHOLDER.DESCRIPCION',
    },

    EMPTY: {
      // No se encontraron documentos de causación
      // No accounting documents found
      MESSAGE: 'ACCOUNTING.CAUSACION.EMPTY.MESSAGE',

      // Intenta con otro rango de fechas o término de búsqueda.
      // Try another date range or search term.
      DESCRIPTION: 'ACCOUNTING.CAUSACION.EMPTY.DESCRIPTION',
    },

    TAB: {
      // Factura
      // Invoice
      FACTURA: 'ACCOUNTING.CAUSACION.TAB.FACTURA',

      // Causación Contable
      // Accounting Entry
      CAUSACION_CONTABLE: 'ACCOUNTING.CAUSACION.TAB.CAUSACION_CONTABLE',

      // Saldos de Cuenta
      // Account Balances
      SALDOS_CUENTA: 'ACCOUNTING.CAUSACION.TAB.SALDOS_CUENTA',

      // Orden de Pago
      // Payment Order
      ORDEN_PAGO: 'ACCOUNTING.CAUSACION.TAB.ORDEN_PAGO',
    },

    LABEL: {
      //totales
      TOTALES: 'ACCOUNTING.CAUSACION.LABEL.TOTALES',

      // No. identificación tercero
      // Third-party identification number
      NO_IDENTIFICACION: 'ACCOUNTING.CAUSACION.LABEL.NO_IDENTIFICACION',

      // Nombre Razón Social
      // Business name
      RAZON_SOCIAL: 'ACCOUNTING.CAUSACION.LABEL.RAZON_SOCIAL',

      // No. Documento
      // Document number
      NO_DOCUMENTO: 'ACCOUNTING.CAUSACION.LABEL.NO_DOCUMENTO',

      // Fecha Expedición
      // Issue date
      FECHA_EXPEDICION: 'ACCOUNTING.CAUSACION.LABEL.FECHA_EXPEDICION',
      // Fecha Inicial
      // Issue date
      FECHA_INICIAL: 'ACCOUNTING.CAUSACION.LABEL.FECHA_INICIAL',
      // Fecha Expedición
      // Issue date
      FECHA_FINAL: 'ACCOUNTING.CAUSACION.LABEL.FECHA_FINAL',

      // Fecha Vencimiento
      // Due date
      FECHA_VENCIMIENTO: 'ACCOUNTING.CAUSACION.LABEL.FECHA_VENCIMIENTO',

      // Fecha Radicación
      // Filing date
      FECHA_RADICACION: 'ACCOUNTING.CAUSACION.LABEL.FECHA_RADICACION',

      // Genera OP
      // Generates payment order
      GENERA_OP: 'ACCOUNTING.CAUSACION.LABEL.GENERA_OP',

      // Total Antes Imp.
      // Total before tax
      TOTAL_ANTES_IMPUESTO: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_ANTES_IMPUESTO',

      // Total Impuesto
      // Tax total
      TOTAL_IMPUESTO: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_IMPUESTO',

      // Total Factura
      // Invoice total
      TOTAL_FACTURA: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_FACTURA',

      // Descripción
      // Description
      DESCRIPCION: 'ACCOUNTING.CAUSACION.LABEL.DESCRIPCION',

      // Total Débito:
      // Total debit
      TOTAL_DEBITO: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_DEBITO',

      // Total Crédito:
      // Total credit
      TOTAL_CREDITO: 'ACCOUNTING.CAUSACION.LABEL.TOTAL_CREDITO',

      // Diferencia (Débito - Crédito):
      // Difference (Debit - Credit)
      DIFERENCIA: 'ACCOUNTING.CAUSACION.LABEL.DIFERENCIA',
    },

    TITLE: {
      // Artículos
      // Items
      ARTICULOS: 'ACCOUNTING.CAUSACION.TITLE.ARTICULOS',

      // Detalle Asiento Contable
      // Accounting entry detail
      DETALLE_ASIENTO: 'ACCOUNTING.CAUSACION.TITLE.DETALLE_ASIENTO',

      // Causación de Cuentas
      // Accounting Entries
      LIST_PAGE: 'ACCOUNTING.CAUSACION.TITLE.LIST_PAGE',

      // Nueva Causación
      // New Accounting Entry
      CREATE_PAGE: 'ACCOUNTING.CAUSACION.TITLE.CREATE_PAGE',

      // Editar Causación
      // Edit Accounting Entry
      EDIT_PAGE: 'ACCOUNTING.CAUSACION.TITLE.EDIT_PAGE',

      // Consultar Causación
      // View Accounting Entry
      VIEW_PAGE: 'ACCOUNTING.CAUSACION.TITLE.VIEW_PAGE',
    },
    SUBTITLE: {
      // Gestión de documentos de causación
      // Accounting documents management
      LIST: 'ACCOUNTING.CAUSACION.SUBTITLE.LIST',

      // Complete los datos del nuevo documento
      // Complete the information for the new document
      CREATE: 'ACCOUNTING.CAUSACION.SUBTITLE.CREATE',

      // Modifique los datos del documento
      // Modify the document information
      EDIT: 'ACCOUNTING.CAUSACION.SUBTITLE.EDIT',

      // Detalle del documento de causación
      // Accounting document details
      VIEW: 'ACCOUNTING.CAUSACION.SUBTITLE.VIEW',
    },

    TOOLTIP: {
      // Buscar tercero
      // Search third party
      // Buscar Articulo
      // Search Aticule
      BUSCAR_TERCERO: 'ACCOUNTING.CAUSACION.TOOLTIP.BUSCAR_TERCERO',
      SEARCH_ARTICLE: 'ACCOUNTING.CAUSACION.TOOLTIP.SEARCH_ARTICLE',
    },

    OPTION: {
      // Sí
      // Yes
      SI: 'ACCOUNTING.CAUSACION.OPTION.SI',

      // No
      // No
      NO: 'ACCOUNTING.CAUSACION.OPTION.NO',
    },

    SECTION: {
      ARTICULOS: 'ACCOUNTING.CAUSACION.SECTION.ARTICULOS',
      DETALLE_ASIENTO: 'ACCOUNTING.CAUSACION.SECTION.DETALLE_ASIENTO',
    },

    BUTTON: {
      // Formato Contable
      // Accounting format
      FORMATO_CONTABLE: 'ACCOUNTING.CAUSACION.BUTTON.FORMATO_CONTABLE',

      // Exportar Asiento
      // Export entry
      EXPORTAR_ASIENTO: 'ACCOUNTING.CAUSACION.BUTTON.EXPORTAR_ASIENTO',

      // Importar Asiento
      // Import entry
      IMPORTAR_ASIENTO: 'ACCOUNTING.CAUSACION.BUTTON.IMPORTAR_ASIENTO',
      //Agregar Artículo}//Add article
      AGREGAR_ARTICULO: 'ACCOUNTING.CAUSACION.BUTTON.AGREGAR_ARTICULO',
    },

    COLUMNS_NAMES: {
      // Código Artículo
      // Article code
      CODIGO_ARTICULO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.CODIGO_ARTICULO',

      // Nombre
      // Name
      NOMBRE: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.NOMBRE',

      // Cantidad
      // Quantity
      CANTIDAD: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.CANTIDAD',

      // Valor Unitario
      // Unit value
      VALOR_UNITARIO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_UNITARIO',

      // Valor Total
      // Total value
      VALOR_TOTAL: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_TOTAL',

      // Porcentaje Impuesto
      // Tax percentage
      PORCENTAJE_IMPUESTO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.PORCENTAJE_IMPUESTO',

      // Valor Antes Impuesto
      // Value before tax
      VALOR_ANTES_IMPUESTO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_ANTES_IMPUESTO',

      // Valor Impuesto
      // Tax value
      VALOR_IMPUESTO: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_IMPUESTO',

      // Totales
      // Totals
      TOTALES: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.TOTALES',
    },
    MESSAGES: {
      WARNING: {
        SELECCIONAR_TERCERO: 'ACCOUNTING.CAUSACION.WARNING.SELECCIONAR_TERCERO',
      },
      SUCCESS: {
        // Tercero encontrado
        // Third party found
        THIRD_PARTY_FOUND: 'ACCOUNTING.CAUSACION.MESSAGE.THIRD_PARTY_FOUND',
        THIRD_PARTY_NAME: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.THIRD_PARTY',
        THIRD_PARTY_NO_IDENTIFICATION:
          'ACCOUNTING.CAUSACION.COLUMNS_NAMES.THIRD_PARTY_NO_IDENTIFICATION',
        // Tercero seleccionado
        // Third party selected
        TERCERO_SELECCIONADO: 'ACCOUNTING.CAUSACION.MESSAGES.TERCERO_SELECCIONADO',
        // Asiento importado exitosamente. Total Débito: {0}, Total Crédito: {1}
        // Entry imported successfully. Total Debit: {0}, Total Credit: {1}
        ASIENTO_IMPORTADO: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.ASIENTO_IMPORTADO',

        // Deducción aplicada exitosamente. {0}% - {1}
        // Deduction applied successfully. {0}% - {1}
        DEDUCCION_APLICADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DEDUCCION_APLICADA',

        // Plantilla exportada exitosamente en formato {0}
        // Template exported successfully in {0} format
        PLANTILLA_EXPORTADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.PLANTILLA_EXPORTADA',

        // Deducción actualizada exitosamente
        // Deduction updated successfully
        DEDUCCION_ACTUALIZADA: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DEDUCCION_ACTUALIZADA',

        // Diferido aplicado correctamente. {0}: {1}
        // Deferred applied successfully. {0}: {1}
        DIFERIDO_APLICADO: 'ACCOUNTING.CAUSACION.MESSAGES.SUCCESS.DIFERIDO_APLICADO',
      },
      ERRORS: {
        // Errores de fecha expedición
        FECHA_EXPEDICION_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_EXPEDICION_REQUIRED',
        FECHA_FUTURA: 'ACCOUNTING.CAUSACION.ERROR.FECHA_FUTURA',

        // Errores de fecha vencimiento
        FECHA_VENCIMIENTO_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_VENCIMIENTO_REQUIRED',
        FECHA_VENC_MENOR_EXPEDICION: 'ACCOUNTING.CAUSACION.ERROR.FECHA_VENC_MENOR_EXPEDICION',

        // Errores de fecha radicación
        FECHA_RADICACION_REQUIRED: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RADICACION_REQUIRED',
        FECHA_RAD_FUTURA: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RAD_FUTURA',
        FECHA_RAD_MENOR_EXPEDICION: 'ACCOUNTING.CAUSACION.ERROR.FECHA_RAD_MENOR_EXPEDICION',

        // Tercero no encontrado El No. Identificación no existe o no está activo. Abriendo selector
        // Third party not found
        THIRD_PARTY_NOT_FOUND: 'ACCOUNTING.CAUSACION.MESSAGE.THIRD_PARTY_NOT_FOUND',
        // Tercero no existe o está inactivo
        // Third party does not exist or is inactive
        TERCERO_NO_EXISTE_O_INACTIVO: 'ACCOUNTING.CAUSACION.MESSAGES.TERCERO_NO_EXISTE_O_INACTIVO',

        // Error al validar tercero
        // Error validating third party
        ERROR_VALIDAR_TERCERO: 'ACCOUNTING.CAUSACION.MESSAGES.ERROR_VALIDAR_TERCERO',
        // Error al buscar terceros
        // Error searching third parties
        ERROR_BUSCAR_TERCEROS: 'ACCOUNTING.CAUSACION.MESSAGES.ERROR_BUSCAR_TERCEROS',

        // Error al cargar información adicional del asiento
        // Error loading additional entry information
        ERROR_CARGAR_ASIENTO: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_CARGAR_ASIENTO',

        // Error al obtener cuentas contables
        // Error retrieving chart of accounts
        ERROR_OBTENER_CUENTAS: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_OBTENER_CUENTAS',

        // Error al obtener terceros
        // Error retrieving third parties
        ERROR_OBTENER_TERCEROS: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_OBTENER_TERCEROS',

        // Error al exportar la plantilla
        // Error exporting template
        ERROR_EXPORTAR_PLANTILLA: 'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.ERROR_EXPORTAR_PLANTILLA',

        // No se encontró la línea de asiento para actualizar
        // Entry line not found for update
        LINEA_ASIENTO_NO_ENCONTRADA:
          'ACCOUNTING.CAUSACION.MESSAGES.ERRORS.LINEA_ASIENTO_NO_ENCONTRADA',
      },
      WARNINGS: {
        // Cuentas contables no encontradas: {0}
        // Chart of accounts not found: {0}
        CUENTAS_NO_ENCONTRADAS: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.CUENTAS_NO_ENCONTRADAS',

        // No hay datos para exportar
        // No data to export
        NO_HAY_DATOS_EXPORTAR: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.NO_HAY_DATOS_EXPORTAR',

        // No hay deducción para editar
        // No deduction available to edit
        NO_HAY_DEDUCCION: 'ACCOUNTING.CAUSACION.MESSAGES.WARNINGS.NO_HAY_DEDUCCION',

        //Solo se pueden editar documentos en estado RECHAZADO
        //Solo se pueden eliminar documentos en estado RECHAZADO
        EDITAR_SOLO_RECHAZADO: 'ACCOUNTING.CAUSACION.ERROR.EDITAR_SOLO_RECHAZADO',
        ELIMINAR_SOLO_RECHAZADO: 'ACCOUNTING.CAUSACION.ERROR.ELIMINAR_SOLO_RECHAZADO',
      },

      HINTS: {
        // Debe ingresar al menos {0} caracteres
        // Enter at least {0} characters
        MINIMO_CARACTERES: 'ACCOUNTING.CAUSACION.MESSAGES.HINTS.MINIMO_CARACTERES',
      },
    },
  },

  ASIENTO: {
    COLUMNS: {
      AGREGAR_LINEA: 'ACCOUNTING.ASIENTO.BUTTON.AGREGAR_LINEA',
      CUENTA_CODIGO: 'ACCOUNTING.ASIENTO.COLUMNS.CUENTA_CODIGO',
      CUENTA_NOMBRE: 'ACCOUNTING.ASIENTO.COLUMNS.CUENTA_NOMBRE',
      DEBITO: 'ACCOUNTING.ASIENTO.COLUMNS.DEBITO',
      CREDITO: 'ACCOUNTING.ASIENTO.COLUMNS.CREDITO',
      BASE_DEDUCCION: 'ACCOUNTING.ASIENTO.COLUMNS.BASE_DEDUCCION',
      CENTRO_COSTOS: 'ACCOUNTING.ASIENTO.COLUMNS.CENTRO_COSTOS',
      TERCERO: 'ACCOUNTING.ASIENTO.COLUMNS.TERCERO',
    },
    PLACEHOLDER: {
      BUSCAR_CUENTA: 'ACCOUNTING.ASIENTO.PLACEHOLDER.BUSCAR_CUENTA',
      VALOR_DEFAULT: 'ACCOUNTING.ASIENTO.PLACEHOLDER.VALOR_DEFAULT',
      BUSCAR_CC: 'ACCOUNTING.ASIENTO.PLACEHOLDER.BUSCAR_CC',
      BUSCAR_TERCERO: 'ACCOUNTING.ASIENTO.PLACEHOLDER.BUSCAR_TERCERO',
    },
    TOOLTIP: {
      BUSCAR_CUENTA: 'ACCOUNTING.ASIENTO.TOOLTIP.BUSCAR_CUENTA',
      BUSCAR_CENTRO_COSTOS: 'ACCOUNTING.ASIENTO.TOOLTIP.BUSCAR_CENTRO_COSTOS',
      BUSCAR_TERCERO: 'ACCOUNTING.ASIENTO.TOOLTIP.BUSCAR_TERCERO',
    },
    ERROR: {
      REQUIRED: 'ACCOUNTING.ASIENTO.ERROR.REQUIRED',
      MIN_ZERO: 'ACCOUNTING.ASIENTO.ERROR.MIN_ZERO',
    },
  },

  ACCOUNTING_FORMAT: {
    TAB: {
      // Datos Generales
      // General Information
      GENERAL: 'ACCOUNTING.ACCOUNTING_FORMAT.TAB.GENERAL',

      // Cuentas Retenedoras
      // Withholding Accounts
      WITHHOLDING_ACCOUNTS: 'ACCOUNTING.ACCOUNTING_FORMAT.TAB.WITHHOLDING_ACCOUNTS',

      // Distribución por Centro de Costos
      // Cost Center Distribution
      COST_CENTER_DISTRIBUTION: 'ACCOUNTING.ACCOUNTING_FORMAT.TAB.COST_CENTER_DISTRIBUTION',
    },

    LABEL: {
      // Código
      // Code
      CODE: 'ACCOUNTING.ACCOUNTING_FORMAT.LABEL.CODE',

      // Nombre
      // Name
      NAME: 'ACCOUNTING.ACCOUNTING_FORMAT.LABEL.NAME',

      // Tipo de Operación
      // Operation type
      OPERATION_TYPE: 'ACCOUNTING.ACCOUNTING_FORMAT.LABEL.OPERATION_TYPE',
    },

    PLACEHOLDER: {
      // Código
      // Code
      CODE: 'ACCOUNTING.ACCOUNTING_FORMAT.PLACEHOLDER.CODE',

      // Nombre
      // Name
      NAME: 'ACCOUNTING.ACCOUNTING_FORMAT.PLACEHOLDER.NAME',

      // Seleccione un tipo de operación
      // Select an operation type
      OPERATION_TYPE: 'ACCOUNTING.ACCOUNTING_FORMAT.PLACEHOLDER.OPERATION_TYPE',
    },

    TOOLTIP: {
      // Código alfanumérico único del formato (máx. 10 caracteres)
      // Unique alphanumeric format code (max. 10 characters)
      CODE: 'ACCOUNTING.ACCOUNTING_FORMAT.TOOLTIP.CODE',

      // Nombre descriptivo del formato contable
      // Descriptive accounting format name
      NAME: 'ACCOUNTING.ACCOUNTING_FORMAT.TOOLTIP.NAME',

      // Seleccione el tipo de operación desde el maestro de conceptos
      // Select the operation type from the concepts catalog
      OPERATION_TYPE: 'ACCOUNTING.ACCOUNTING_FORMAT.TOOLTIP.OPERATION_TYPE',

      RESUME_SAVE: 'ACCOUNTING.ACCOUNTING_PARAMETERS.TOOLTIP.RESUME_SAVE', // Reanudando guardado...
      SAVING: 'ACCOUNTING.ACCOUNTING_PARAMETERS.TOOLTIP.SAVING', // Guardando...
    },
    MESSAGES: {
      SUCCESS: {
        ACCOUNT_SELECTED: 'ACCOUNTING.ACCOUNTING_FORMAT.MESSAGES.SUCCESS.ACCOUNT_SELECTED',
      },
    },
  },

  DISTRIBUTION_COST_CENTER: {
    LABEL: {
      // Tipo Centro de Costos
      // Cost center type
      COST_CENTER_TYPE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.COST_CENTER_TYPE',

      // Centro de Costo
      // Cost center
      COST_CENTER: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.COST_CENTER',

      // Código Centro de Costos
      // Cost center code
      COST_CENTER_CODE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.COST_CENTER_CODE',

      // Nombre Centro de Costos
      // Cost center name
      COST_CENTER_NAME: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.COST_CENTER_NAME',

      // Porcentaje
      // Percentage
      PERCENTAGE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.LABEL.PERCENTAGE',
    },

    PLACEHOLDER: {
      // Seleccione un tipo de centro de costo
      // Select a cost center type
      COST_CENTER_TYPE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.COST_CENTER_TYPE',

      // Seleccione un centro de costo
      // Select a cost center
      COST_CENTER: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.COST_CENTER',

      // Seleccione un centro de costo
      // Select a cost center
      COST_CENTER_CODE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.COST_CENTER_CODE',

      // Seleccione un centro de costo
      // Select a cost center
      COST_CENTER_NAME: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.COST_CENTER_NAME',

      // Porcentaje(%)
      // Percentage (%)
      PERCENTAGE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.PLACEHOLDER.PERCENTAGE',
    },

    TOOLTIP: {
      // Seleccione el tipo de centro de costo
      // Select the cost center type
      COST_CENTER_TYPE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.COST_CENTER_TYPE',

      // Seleccione el centro de costo
      // Select the cost center
      COST_CENTER: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.COST_CENTER',

      // Código del centro de costos (automático)
      // Cost center code (automatic)
      COST_CENTER_CODE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.COST_CENTER_CODE',

      // Nombre del centro de costos (automático)
      // Cost center name (automatic)
      COST_CENTER_NAME: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.COST_CENTER_NAME',

      // Porcentaje de distribución (0-100)
      // Distribution percentage (0-100)
      PERCENTAGE: 'ACCOUNTING.DISTRIBUTION_COST_CENTER.TOOLTIP.PERCENTAGE',
    },
  },

  ACCOUNTING_PARAMETERS: {
    LABEL: {
      PARAMETERS_TITLE: 'OPTIONS_ACCOUNTING_PARAMETERS', // Parámetros
      PARAMETERS_SUBTITLE: 'ACCOUNTING.PARAMETER.SUBTITLE', // Configuración general de la entidad
      PARAMETERS_SYSTEM_DATE: 'LAYOUT.SYSTEM_DATE', // Fecha del sistema
      PARAMETERS_LIB_EMPTY_MESSAGE: 'ACCOUNTING.PARAMETER.EMPTY_MESSAGE', // Cargando Parámetros
      PARAMETERS_LIB_EMPTY_DESCRIPTION: 'ACCOUNTING.PARAMETER.EMPTY_DESCRIPTION', // Espere Por favor...
      PARAMETERS_ENTITY_INFORMATION: 'ACCOUNTING.PARAMETER.ENTITY_INFORMATION',
      PARAMETERS_CONFIGURATION_DATA_LOADED_SUCCESSFULLY:
        'ACCOUNTING.PARAMETER.CONFIGURATION_DATA_LOADED_SUCCESSFULLY', // Datos cargados de configuración
      PARAMETERS_OPERATION: 'ACCOUNTING.PARAMETER.OPERATION_PARAMETERS', // Parámetros de operación
      PARAMETERS_CURRENT_SYSTEM_DATE_REQUIRED: 'ACCOUNTING.PARAMETER.CURRENT_SYSTEM_DATE_REQUIRED', // La fecha del Sistema es requerida
      PARAMETERS_AFFECTS_PUBLIC_BUDGET: 'ACCOUNTING.PARAMETER.AFFECTS_PUBLIC_BUDGET', // Afecta Presupuesto Público
      PARAMETERS_MULTIPLAN_ACCOUNTING: 'ACCOUNTING.PARAMETER.MULTIPLAN_ACCOUNTING', // Multiplan Contable
      PARAMETERS_APPROVAL_OF_CAUSATION: 'ACCOUNTING.PARAMETER.APPROVAL_OF_CAUSATION', // Aprobación de causación
      // Apunta a HANDLES_DEFERRED_ACCOUNTING y no a HANDLES_DEFERRED: la segunda nunca se cargo, y
      // la primera es la que el catalogo tiene traducida en los dos idiomas. Se reapunta en vez de
      // cargar una clave nueva con el mismo texto.
      PARAMETERS_HANDLES_DEFERRED: 'ACCOUNTING.PARAMETER.HANDLES_DEFERRED_ACCOUNTING', // Maneja diferidos
      PARAMETERS_AUTOMATIC_PROCESSES: 'ACCOUNTING.PARAMETER.AUTOMATIC_PROCESSES', // Procesos Automáticos
      PARAMETERS_AUTOMATIC_PROCESSES_TITLE: 'ACCOUNTING.PARAMETER.AUTOMATIC_PROCESSES_TITLE', // Se actualizan automáticamente
      PARAMETERS_COMPANY: 'ACCOUNTING.PARAMETER.COMPANY', // Compania. Clave propia: COLUMNS.FIRST_NAME es generica y la comparte todo el ecosistema
      PARAMETERS_NIT: 'VALUES.NIT',
      // Número de Identificación Tributaria (NIT) de la entidad según registro mercantil
      // Clave propia, y no VALUES.NIT: esa es generica y la comparte el resumen de la derecha,
      // que muestra el NIT del TERCERO. Son dos numeros distintos en la misma pantalla.
      PARAMETERS_HANDLES_DEPRECIATION: 'ACCOUNTING.PARAMETER.DEPRECIATION',

      PARAMETERS_LEGAL_REPRESENTATIVE_NIT: 'ACCOUNTING.PARAMETER.LEGAL_REPRESENTATIVE_NIT', // NIT del representante legal
      PARAMETERS_VALIDITY: 'COLUMNS.VALIDITY', // Vigencia
      PARAMETERS_DEFERRED_MONTH: 'ACCOUNTING.PARAMETER.DEFERRED_MONTH', // Mes diferido
      PARAMETERS_LAST_CLOSED_MONTH: 'ACCOUNTING.PARAMETER.LAST_CLOSED_MONTH', // Último mes cerrado
      PARAMETERS_DEPRECIATION_MONTH: 'ACCOUNTING.PARAMETER.DEPRECIATION_MONTH', // Mes de depreciación
      PARAMETERS_NOT_DEFINED: 'ACCOUNTING.PARAMETER.NOT_DEFINED', // No definido
      PARAMETERS_ACCOUNTING_BEHAVIOUR: 'ACCOUNTING.PARAMETER.ACCOUNTING_BEHAVIOUR', // Comportamiento contable
      PARAMETERS_ACCOUNTING_BEHAVIOUR_HINT: 'ACCOUNTING.PARAMETER.ACCOUNTING_BEHAVIOUR_HINT', // Que cambian esas opciones
      PARAMETERS_READ_ONLY: 'ACCOUNTING.PARAMETER.READ_ONLY', // Solo lectura
    },

    /** Contexto de cada interruptor en el proceso contable: la (i) junto al rotulo (R3-14, 14-oct-2026). */
    CONTEXTO: {
      AFFECTS_PUBLIC_BUDGET: 'ACCOUNTING.PARAMETER.AFFECTS_PUBLIC_BUDGET_CONTEXT',
      MULTIPLAN_ACCOUNTING: 'ACCOUNTING.PARAMETER.MULTIPLAN_ACCOUNTING_CONTEXT',
      APPROVAL_OF_CAUSATION: 'ACCOUNTING.PARAMETER.APPROVAL_OF_CAUSATION_CONTEXT',
      HANDLES_DEFERRED: 'ACCOUNTING.PARAMETER.HANDLES_DEFERRED_CONTEXT',
      HANDLES_DEPRECIATION: 'ACCOUNTING.PARAMETER.HANDLES_DEPRECIATION_CONTEXT',
      SYSTEM_DATE: 'ACCOUNTING.PARAMETER.SYSTEM_DATE_CONTEXT',
      OPERATING_CURRENCY: 'ACCOUNTING.PARAMETER.OPERATING_CURRENCY_CONTEXT',
    },
    TOOLTIP: {
      PARAMETERS_CURRENT_SYSTEM_DATE: 'ACCOUNTING.PARAMETER.CURRENT_SYSTEM_DATE_TOOLTIP', // Fecha actual del sistema para operaciones contables
      PARAMETERS_AFFECTS_PUBLIC_BUDGET: 'ACCOUNTING.PARAMETER.AFFECTS_PUBLIC_BUDGET_TOOLTIP', // Indica si las operaciones afectan el presupuesto público
      PARAMETERS_MULTIPLAN_ACCOUNTING: 'ACCOUNTING.PARAMETER.MULTIPLAN_ACCOUNTING_TOOLTIP', // Habilita la gestión de múltiples planes contables
      PARAMETERS_APPROVAL_OF_CAUSATION: 'ACCOUNTING.PARAMETER.APPROVAL_OF_CAUSATION_TOOLTIP', // Requiere aprobación para los procesos de causación contable
      PARAMETERS_HANDLES_DEFERRED: 'ACCOUNTING.PARAMETER.HANDLES_DEFERRED_TOOLTIP', // Indica si la entidad maneja procesos de diferidos contables
      PARAMETERS_HANDLES_DEPRECIATION: 'ACCOUNTING.PARAMETER.HANDLES_DEPRECIATION_TOOLTIP',
      PARAMETERS_AUTOMATIC_PROCESSES: 'ACCOUNTING.PARAMETER.AUTOMATIC_PROCESSES_TOOLTIP', // Indica si la entidad maneja procesos automáticos
      PARAMETERS_COMPANY: 'ACCOUNTING.PARAMETER.COMPANY_TOOLTIP', // Compania a la que pertenecen estos parametros
      PARAMETERS_NIT: 'VALUES.NIT_TOOLTIP', // Número de Identificación Tributaria de la entidad
      PARAMETERS_VALIDITY: 'COLUMNS.VALIDITY_TOOLTIP', // Año contable actual de la entidad
      PARAMETERS_DEFERRED_MONTH: 'ACCOUNTING.PARAMETER.DEFERRED_MONTH_TOOLTIP', // Mes actual para el proceso de diferidos contables
      PARAMETERS_LAST_CLOSED_MONTH: 'ACCOUNTING.PARAMETER.LAST_CLOSED_MONTH_TOOLTIP', // Último período contable cerrado. La fecha del sistema no puede ser inferior a este valor
      PARAMETERS_DEPRECIATION_MONTH: 'ACCOUNTING.PARAMETER.DEPRECIATION_MONTH_TOOLTIP', // Mes actual para el cálculo de depreciaciones de activos fijos
    },

    ACTION: {
      REFRESH: 'ACTIONS.REFRESH', // Refrescar
      CANCEL: 'ACTIONS.CANCEL', // Cancelar
      SAVE: 'ACTIONS.SAVE', // Guardar
      SAVE_RELOAD: 'ACTIONS.SAVE_RELOAD', // Reanudando guardado...
      SAVING: 'ACTIONS.SAVING', // Guardando...
      PENDING_SAVE: 'ACTIONS.PENDING_SAVE', // Hay una operación de guardado pendiente. Reanudando...
      SAVING_CHANGES: 'ACTIONS.SAVING_CHANGES', // Guardando cambios...
      SAVING_CHANGES_RELOAD: 'ACTIONS.SAVING_CHANGES_RELOAD', // Guardando cambios. Por favor no cierre esta página...
      SAVING_CHANGES_RELOAD_PENDING: 'ACTIONS.SAVING_CHANGES_RELOAD_PENDING', // Hay una operación de guardado pendiente. Reanudando...
      SAVING_PARAMETERS: 'ACTIONS.CARGANDO_PARAMETROS', // Cargando parámetros...
      CREATE: 'ACTIONS.CREATE', //Crear
      EDIT: 'ACTIONS.EDIT', //Editar
      VIEW: 'ACTIONS.VIEW', //Consultar
      MODIFY: 'ACTIONS.MODIFY', //Modificar
      DELETE: 'ACTIONS.DELETE', //Eliminar
      CONSULT: 'ACTIONS.CONSULT', //Consultar
    },

    MESSAGES: {
      NOT_DEFINED: 'ACCOUNTING.PARAMETER.NOT_DEFINED', // No definido
      PENDING_SAVE: 'ACTIONS.SAVING_CHANGES_RELOAD_PENDING', // Hay una operacion de guardado pendiente. Reanudando...
      LOAD_ERROR: 'ACCOUNTING.CHART_OF_ACCOUNTS.ERROR.SYSTEM_PARAMETERS_LOAD', // Error al consultar parametros del sistema
      SAVED: 'ACCOUNTING.PARAMETER.SAVED', // Parametros guardados correctamente
      SAVE_ERROR: 'ACCOUNTING.PARAMETER.ERROR.SAVE', // Ocurrio un error al guardar los parametros
      NO_CHANGES: 'COMMON.CRUD.NO_CHANGES', // No hay cambios para guardar
      REQUIRED: 'COMMON.VALIDATION.REQUIRED', // Campo obligatorio
      DATE_FUTURE: 'ACCOUNTING.PARAMETER.ERROR.DATE_FUTURE', // La fecha no puede ser superior a la fecha actual
      DATE_BEFORE_2000: 'ACCOUNTING.PARAMETER.ERROR.DATE_BEFORE_2000', // No se permiten fechas anteriores al año 2000
      LAST_CLOSED_NOT_SET: 'ACCOUNTING.PARAMETER.ERROR.LAST_CLOSED_NOT_SET', // No se ha configurado el ultimo mes cerrado
      DATE_IN_CLOSED_MONTH: 'ACCOUNTING.PARAMETER.ERROR.DATE_IN_CLOSED_MONTH', // ...no puede estar en el mes cerrado ({{mes}})
      DATE_BEFORE_CLOSED_MONTH: 'accounting.parametro.error.fecha.inferior', // ...no puede ser anterior al ultimo mes cerrado ({0})
    },

    CONFIRM_DIALOGS: {
      REFRESH: {
        TITLE: 'ACTIONS.CONFIRM_REFRESH.TITLE', // Cambios sin guardar
        MESSAGE: 'ACTIONS.CONFIRM_REFRESH.MESSAGE', // Tiene cambios sin guardar. ¿Está seguro de que desea salir? Los cambios se perderán.
        CONFIRM_LABEL: 'ACTIONS.CONFIRM_REFRESH.CONFIRM', // 'Sí, refrescar
        CANCEL_LABEL: 'ACTIONS.CANCEL', // Cancelar
      },
      CAN_DEACTIVATE: {
        TITLE: 'ACTIONS.CONFIRM_DEACTIVATE.TITLE', // Cambios sin guardar
        MESSAGE: 'ACTIONS.CONFIRM_DEACTIVATE.MESSAGE', // Tiene cambios sin guardar. ¿Está seguro de que desea salir? Los cambios se perderán.
        CONFIRM_LABEL: 'ACTIONS.CONFIRM_DEACTIVATE.CONFIRM', // Continuar editando
        CANCEL_LABEL: 'ACTIONS.CONFIRM_DEACTIVATE.CANCEL', // Sí, salir
      },
    },
  },

  ANNULLMENT: {
    TITLE: {
      LIST: 'OPTIONS_JOURNAL_ENTRY_ANNULMENT',
      VIEW: 'ACCOUNTING.ANNULLMENT.TITLE.VIEW',
      BULK_ANNULLMENT: 'ACCOUNTING.ANNULLMENT.TITLE.BULK_ANNULLMENT',
      CONFIRM_ANNULLMENT: 'ACCOUNTING.ANNULLMENT.TITLE.CONFIRM_ANNULLMENT',
    },

    SUBTITLE: {
      LIST: 'ACCOUNTING.ANNULLMENT.SUBTITLE.LIST',
      VIEW: 'ACCOUNTING.ANNULLMENT.SUBTITLE.VIEW',
      EMPTY: 'ACCOUNTING.ANNULLMENT.SUBTITLE.EMPTY',
    },

    COUNTER: {
      SINGULAR: 'ACCOUNTING.ANNULLMENT.COUNTER.SINGULAR',
      PLURAL: 'ACCOUNTING.ANNULLMENT.COUNTER.PLURAL',
      SHOWING: 'ACCOUNTING.ANNULLMENT.COUNTER.SHOWING',
      OF: 'ACCOUNTING.ANNULLMENT.COUNTER.OF',
    },

    PLACEHOLDER: {
      SEARCH: 'ACCOUNTING.ANNULLMENT.PLACEHOLDER.SEARCH',
      DATE_START: 'ACCOUNTING.ANNULLMENT.PLACEHOLDER.DATE_START',
      DATE_END: 'ACCOUNTING.ANNULLMENT.PLACEHOLDER.DATE_END',
      ANNULLMENT_REASON: 'ACCOUNTING.ANNULLMENT.PLACEHOLDER.ANNULLMENT_REASON',
    },

    LABEL: {
      ANNULLMENT_REASON: 'ACCOUNTING.ANNULLMENT.LABEL.ANNULLMENT_REASON',
      CODE: 'ACCOUNTING.ANNULLMENT.LABEL.CODE',
      CONCEPT: 'ACCOUNTING.ANNULLMENT.LABEL.CONCEPT',
      TYPE: 'ACCOUNTING.ANNULLMENT.LABEL.TYPE',
      IDENTIFICATION: 'ACCOUNTING.ANNULLMENT.LABEL.IDENTIFICATION',
      BUSINESS_NAME: 'ACCOUNTING.ANNULLMENT.LABEL.BUSINESS_NAME',
      DOC_NUMBER: 'ACCOUNTING.ANNULLMENT.LABEL.DOC_NUMBER',
      DOC_DATE: 'ACCOUNTING.ANNULLMENT.LABEL.DOC_DATE',
      TOTAL_DEBIT: 'ACCOUNTING.ANNULLMENT.LABEL.TOTAL_DEBIT',
      TOTAL_CREDIT: 'ACCOUNTING.ANNULLMENT.LABEL.TOTAL_CREDIT',
      DIFFERENCE: 'ACCOUNTING.ANNULLMENT.LABEL.DIFFERENCE',
      BALANCED: 'ACCOUNTING.ANNULLMENT.LABEL.BALANCED',
      NOT_BALANCED: 'ACCOUNTING.ANNULLMENT.LABEL.NOT_BALANCED',

      // Etiquetas para el modo vista
      VIEW_TITLE: 'ACCOUNTING.ANNULLMENT.LABEL.VIEW_TITLE',
      ENTRY_DATA: 'ACCOUNTING.ANNULLMENT.LABEL.ENTRY_DATA',
      ENTRY_DETAIL: 'ACCOUNTING.ANNULLMENT.LABEL.ENTRY_DETAIL',
      LOADING_DETAIL: 'ACCOUNTING.ANNULLMENT.LABEL.LOADING_DETAIL',
      NO_IDENTIFICATION: 'ACCOUNTING.ANNULLMENT.LABEL.NO_IDENTIFICATION',
      BUSINESS_NAME_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.BUSINESS_NAME_FULL',
      DOC_NUMBER_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.DOC_NUMBER_FULL',
      ENTRY_CODE: 'ACCOUNTING.ANNULLMENT.LABEL.ENTRY_CODE',
      CONCEPT_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.CONCEPT_FULL',
      TYPE_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.TYPE_FULL',
      DESCRIPTION_FULL: 'ACCOUNTING.ANNULLMENT.LABEL.DESCRIPTION_FULL',
      ACCOUNT_CODE: 'ACCOUNTING.ANNULLMENT.LABEL.ACCOUNT_CODE',
      ACCOUNT_NAME: 'ACCOUNTING.ANNULLMENT.LABEL.ACCOUNT_NAME',
      DEBIT_VALUE: 'ACCOUNTING.ANNULLMENT.LABEL.DEBIT_VALUE',
      CREDIT_VALUE: 'ACCOUNTING.ANNULLMENT.LABEL.CREDIT_VALUE',
      DEDUCTION_BASE: 'ACCOUNTING.ANNULLMENT.LABEL.DEDUCTION_BASE',
      BANK: 'ACCOUNTING.ANNULLMENT.LABEL.BANK',
      COST_CENTER: 'ACCOUNTING.ANNULLMENT.LABEL.COST_CENTER',
      THIRD_PARTY_ID: 'ACCOUNTING.ANNULLMENT.LABEL.THIRD_PARTY_ID',
      THIRD_PARTY_NAME: 'ACCOUNTING.ANNULLMENT.LABEL.THIRD_PARTY_NAME',
      AUTO_GENERATED: 'ACCOUNTING.ANNULLMENT.LABEL.AUTO_GENERATED',
      ENTRY_DESCRIPTION: 'ACCOUNTING.ANNULLMENT.LABEL.ENTRY_DESCRIPTION',
    },

    COLUMNS: {
      CODE: 'ACCOUNTING.ANNULLMENT.COLUMNS.CODE',
      CONCEPT: 'ACCOUNTING.ANNULLMENT.COLUMNS.CONCEPT',
      TYPE: 'ACCOUNTING.ANNULLMENT.COLUMNS.TYPE',
      IDENTIFICATION: 'ACCOUNTING.ANNULLMENT.COLUMNS.IDENTIFICATION',
      BUSINESS_NAME: 'ACCOUNTING.ANNULLMENT.COLUMNS.BUSINESS_NAME',
      DOC_NUMBER: 'ACCOUNTING.ANNULLMENT.COLUMNS.DOC_NUMBER',
      DOC_DATE: 'ACCOUNTING.ANNULLMENT.COLUMNS.DOC_DATE',
    },

    ACTION: {
      REFRESH: 'ACTIONS.REFRESH',
      CANCEL: 'ACTIONS.CANCEL',
      SAVE: 'ACTIONS.SAVE',
      SAVE_RELOAD: 'ACTIONS.SAVE_RELOAD',
      SAVING: 'ACTIONS.SAVING',
      PENDING_SAVE: 'ACTIONS.PENDING_SAVE',
      SAVING_CHANGES_RELOAD: 'ACTIONS.SAVING_CHANGES_RELOAD',
      ANNULL: 'ACTION.ANNUL',
      BACK: 'ACTIONS.BACK',
      CONFIRM_ANNULL: 'ACTION.ANNUL',
      CONSULT: 'ACTIONS.ANNULLMENT.BUTTON.CONSULT',
    },

    EMPTY: {
      MESSAGE: 'ACCOUNTING.ANNULLMENT.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.ANNULLMENT.EMPTY.DESCRIPTION',
    },

    CONFIRM_DIALOG: {
      TITLE: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.TITLE',
      DESCRIPTION: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.DESCRIPTION',
      CONFIRM_LABEL: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.CONFIRM_LABEL',
      CANCEL_LABEL: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.CANCEL_LABEL',
      REASON_REQUIRED: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.REASON_REQUIRED',
      REASON_MAX_LENGTH: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.REASON_MAX_LENGTH',
      NO_DOCUMENTS: 'ACCOUNTING.ANNULLMENT.CONFIRM_DIALOG.NO_DOCUMENTS',
    },

    LOADING: {
      DETAIL: 'ACCOUNTING.ANNULLMENT.LOADING.DETAIL',
    },

    VALIDATION: {
      SEARCH_MIN_LENGTH: 'ACCOUNTING.ANNULLMENT.VALIDATION.SEARCH_MIN_LENGTH',
      SEARCH_MAX_LENGTH: 'ACCOUNTING.ANNULLMENT.VALIDATION.SEARCH_MAX_LENGTH',
      DATE_INVALID: 'ACCOUNTING.ANNULLMENT.VALIDATION.DATE_INVALID',
      /** Rango fuera de la vigencia activa; la clave es la del servicio (ERR-ANU-08). */
      OUT_OF_VIGENCIA: 'accounting.anulacion.rango.fuera.vigencia.message',
    },

    ALERT: {
      ERROR_TITLE: 'ACCOUNTING.ANNULLMENT.ALERT.ERROR_TITLE',
      SUCCESS_TITLE: 'ACCOUNTING.ANNULLMENT.ALERT.SUCCESS_TITLE',
      ERROR_LOADING_DETAIL: 'ACCOUNTING.ANNULLMENT.ALERT.ERROR_LOADING_DETAIL',
    },

    TAB: {
      FACTURA: 'ACCOUNTING.ANNULLMENT.TAB.FACTURA',
      CAUSACION_CONTABLE: 'ACCOUNTING.ANNULLMENT.TAB.CAUSACION_CONTABLE',
      SALDOS_CUENTA: 'ACCOUNTING.ANNULLMENT.TAB.SALDOS_CUENTA',
      ORDEN_PAGO: 'ACCOUNTING.ANNULLMENT.TAB.ORDEN_PAGO',
    },

    SECTION: {
      ARTICULOS: 'ACCOUNTING.ANNULLMENT.SECTION.ARTICULOS',
      DETALLE_ASIENTO: 'ACCOUNTING.ANNULLMENT.SECTION.DETALLE_ASIENTO',
      RESUMEN: 'ACCOUNTING.ANNULLMENT.SECTION.RESUMEN',
    },

    DETAIL: {
      NO_IDENTIFICACION: 'ACCOUNTING.ANNULLMENT.DETAIL.NO_IDENTIFICACION',
      NOMBRE_RAZON_SOCIAL: 'ACCOUNTING.ANNULLMENT.DETAIL.NOMBRE_RAZON_SOCIAL',
      NUMERO_DOCUMENTO: 'ACCOUNTING.ANNULLMENT.DETAIL.NUMERO_DOCUMENTO',
      FECHA_EXPEDICION: 'ACCOUNTING.ANNULLMENT.DETAIL.FECHA_EXPEDICION',
      FECHA_VENCIMIENTO: 'ACCOUNTING.ANNULLMENT.DETAIL.FECHA_VENCIMIENTO',
      FECHA_RADICACION: 'ACCOUNTING.ANNULLMENT.DETAIL.FECHA_RADICACION',
      GENERA_OP: 'ACCOUNTING.ANNULLMENT.DETAIL.GENERA_OP',
      TOTAL_ANTES_IMPUESTO: 'ACCOUNTING.ANNULLMENT.DETAIL.TOTAL_ANTES_IMPUESTO',
      TOTAL_IMPUESTO: 'ACCOUNTING.ANNULLMENT.DETAIL.TOTAL_IMPUESTO',
      TOTAL_FACTURA: 'ACCOUNTING.ANNULLMENT.DETAIL.TOTAL_FACTURA',
      DESCRIPCION: 'ACCOUNTING.ANNULLMENT.DETAIL.DESCRIPCION',
      ASIENTO_HEADER: 'ACCOUNTING.ANNULLMENT.DETAIL.ASIENTO_HEADER',
    },

    DETAIL_TABLE: {
      ARTICULO: {
        CODE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.CODE',
        NAME: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.NAME',
        QUANTITY: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.QUANTITY',
        UNIT_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.UNIT_VALUE',
        TOTAL_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.TOTAL_VALUE',
        TAX_PERCENTAGE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.TAX_PERCENTAGE',
        VALUE_BEFORE_TAX: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.VALUE_BEFORE_TAX',
        TAX_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.ARTICULO.TAX_VALUE',
      },
      MOVIMIENTO: {
        ACCOUNT_CODE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.ACCOUNT_CODE',
        ACCOUNT_NAME: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.ACCOUNT_NAME',
        DEBIT: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.DEBIT',
        CREDIT: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.CREDIT',
        DEDUCTION_BASE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.DEDUCTION_BASE',
        COST_CENTER_CODE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.COST_CENTER_CODE',
        THIRD_PARTY_ID: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.THIRD_PARTY_ID',
        THIRD_PARTY_NAME: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.THIRD_PARTY_NAME',
        BANK: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.BANK',
        DOC_NUMBER_SHORT: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.DOC_NUMBER_SHORT',
        DEBIT_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.DEBIT_VALUE',
        CREDIT_VALUE: 'ACCOUNTING.ANNULLMENT.DETAIL_TABLE.MOVIMIENTO.CREDIT_VALUE',
      },
    },

    TOOLTIP: {
      NO_IDENTIFICATION: 'ACCOUNTING.ANNULLMENT.TOOLTIP.NO_IDENTIFICATION',
      BUSINESS_NAME: 'ACCOUNTING.ANNULLMENT.TOOLTIP.BUSINESS_NAME',
      DOC_NUMBER: 'ACCOUNTING.ANNULLMENT.TOOLTIP.DOC_NUMBER',
      ENTRY_CODE: 'ACCOUNTING.ANNULLMENT.TOOLTIP.ENTRY_CODE',
      CONCEPT: 'ACCOUNTING.ANNULLMENT.TOOLTIP.CONCEPT',
      TYPE: 'ACCOUNTING.ANNULLMENT.TOOLTIP.TYPE',
      DESCRIPTION: 'ACCOUNTING.ANNULLMENT.TOOLTIP.DESCRIPTION',
    },

    ERROR: {
      REASON_REQUIRED: 'Se debe ingresar un motivo de anulación',
      REASON_MAX_LENGTH: 'El motivo de anulación no puede exceder los 300 caracteres',
      TYPE_ANNULMENT_CONCEPT_NOT_EXISTS:
        'Para el Concepto no existe Tipo de Asiento de Anulación, debe crearlo antes de realizar el proceso de anulación',
      BANK_CLOSED:
        'El asiento no se puede anular porque se afectaría el saldo de bancos y para la fecha los bancos están cerrados',
      OVERDRAFT_NOT_ALLOWED:
        'El asiento no se puede anular porque se afectaría el saldo de bancos y se sobregiraría',
      BATCH_ROLLBACK:
        'Error en la anulación masiva. El proceso ha sido revertido. Verifique los mensajes anteriores.',
      EMPTY_LIST: 'No se encontraron asientos para anular en el rango seleccionado',
      OUT_OF_VIGENCIA: 'El rango de fechas debe estar dentro de la vigencia activa',
      ANNULMENT_NOT_ALLOWED: 'No se permite anular este asiento',
      DOCUMENT_ALREADY_ANNULLED: 'El asiento ya ha sido anulado previamente',
      ENTRY_NOT_FOUND: 'No se encontró el asiento solicitado',
    },
  },

  DEPRECIATION: {
    COUNTER: {
      LABEL_SINGULAR: 'ACCOUNTING.DEPRECIATION.COUNTER.LABEL_SINGULAR',
      LABEL_PLURAL: 'ACCOUNTING.DEPRECIATION.COUNTER.LABEL_PLURAL',
    },

    EMPTY: {
      MESSAGE: 'ACCOUNTING.DEPRECIATION.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.DEPRECIATION.EMPTY.DESCRIPTION',
    },

    LABEL: {
      TIPO_ASIENTO: 'ACCOUNTING.DEPRECIATION.LABEL.TIPO_ASIENTO',
      PERIOD: 'ACCOUNTING.DEPRECIATION.LABEL.PERIOD',
      CONSECUTIVO_ASIENTO: 'ACCOUNTING.DEPRECIATION.LABEL.CONSECUTIVO_ASIENTO',
      USUARIO_ELABORA: 'ACCOUNTING.DEPRECIATION.LABEL.USUARIO_ELABORA',
      FECHA_ASIENTO: 'ACCOUNTING.DEPRECIATION.LABEL.FECHA_ASIENTO',
      FECHA_REGISTRO: 'ACCOUNTING.DEPRECIATION.LABEL.FECHA_REGISTRO',
      OBSERVATIONS: 'ACCOUNTING.DEPRECIATION.LABEL.OBSERVATIONS',
    },
    TOOLTIP: {
      TIPO_ASIENTO: 'ACCOUNTING.DEPRECIATION.TOOLTIP.TIPO_ASIENTO',
      MES: 'ACCOUNTING.DEPRECIATION.TOOLTIP.MES',
      CONSECUTIVO_ASIENTO: 'ACCOUNTING.DEPRECIATION.TOOLTIP.CONSECUTIVO_ASIENTO',
      USUARIO_ELABORA: 'ACCOUNTING.DEPRECIATION.TOOLTIP.USUARIO_ELABORA',
      FECHA_ASIENTO: 'ACCOUNTING.DEPRECIATION.TOOLTIP.FECHA_ASIENTO',
      FECHA_REGISTRO: 'ACCOUNTING.DEPRECIATION.TOOLTIP.FECHA_REGISTRO',
      DESCRIPCION: 'ACCOUNTING.DEPRECIATION.TOOLTIP.DESCRIPCION',
    },
    TITLE: {
      LIST: 'ACCOUNTING.DEPRECIATION.TITLE.LIST',
      CREATE: 'ACCOUNTING.DEPRECIATION.TITLE.CREATE',
      VIEW: 'ACCOUNTING.DEPRECIATION.TITLE.VIEW',
    },
    SUBTITLE: {
      LIST: 'ACCOUNTING.DEPRECIATION.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.DEPRECIATION.SUBTITLE.CREATE',
      VIEW: 'ACCOUNTING.DEPRECIATION.SUBTITLE.VIEW',
    },
    COLUMN: {
      DEPRECIATION_AMOUNT: 'ACCOUNTING.DEPRECIATION.COLUMN.DEPRECIATION_AMOUNT', //Valor Diferido
    },
    DEFERRED_MONTH_TABLE: {
      COLUMN: {
        DOCUMENT: 'ACCOUNTING.DEPRECIATION.COUNTER.LABEL_SINGULAR',
        DEBIT_ACCOUNT: 'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.DEBIT_ACCOUNT', // Cuenta Débito, Debit account

        CREDIT_ACCOUNT: 'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.CREDIT_ACCOUNT', // Cuenta Crédito, Credit account

        IDENTIFICATION_NUMBER:
          'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.IDENTIFICATION_NUMBER', // N. Identificación, Identification number

        NAME_OR_BUSINESS_NAME:
          'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.NAME_OR_BUSINESS_NAME', // Nombre o Razón Social, Name or business name

        COST_CENTER: 'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.COST_CENTER', // Centro de Costos, Cost center

        DEBIT_VALUE: 'ACCOUNTING.DEPRECIATION.DEFERRED_MONTH_TABLE.COLUMN.DEBIT_VALUE', // Valor Débito, Debit value

        CREDIT_VALUE: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.CREDIT_VALUE', // Valor Crédito, Credit value
      },
    },
  },
  ENTRY_DEFERRED: {
    COUNTER: {
      LABEL_SINGULAR: 'ACCOUNTING.ENTRY_DEFERRED.COUNTER.LABEL_SINGULAR',
      LABEL_PLURAL: 'ACCOUNTING.ENTRY_DEFERRED.COUNTER.LABEL_PLURAL',
    },

    EMPTY: {
      MESSAGE: 'ACCOUNTING.ENTRY_DEFERRED.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.ENTRY_DEFERRED.EMPTY.DESCRIPTION',
    },

    LABEL: {
      TIPO_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.TIPO_ASIENTO',
      MES: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.MES',
      CONSECUTIVO_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.CONSECUTIVO_ASIENTO',
      USUARIO_ELABORA: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.USUARIO_ELABORA',
      FECHA_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.FECHA_ASIENTO',
      FECHA_REGISTRO: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.FECHA_REGISTRO',
      DESCRIPCION: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.DESCRIPCION',
    },
    TOOLTIP: {
      TIPO_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.TIPO_ASIENTO',
      MES: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.MES',
      CONSECUTIVO_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.CONSECUTIVO_ASIENTO',
      USUARIO_ELABORA: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.USUARIO_ELABORA',
      FECHA_ASIENTO: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.FECHA_ASIENTO',
      FECHA_REGISTRO: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.FECHA_REGISTRO',
      DESCRIPCION: 'ACCOUNTING.ENTRY_DEFERRED.TOOLTIP.DESCRIPCION',
    },
    TITLE: {
      LIST: 'ACCOUNTING.ENTRY_DEFERRED.TITLE.LIST',
      CREATE: 'ACCOUNTING.ENTRY_DEFERRED.TITLE.CREATE',
      VIEW: 'ACCOUNTING.ENTRY_DEFERRED.TITLE.VIEW',
    },
    SUBTITLE: {
      LIST: 'ACCOUNTING.ENTRY_DEFERRED.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.ENTRY_DEFERRED.SUBTITLE.CREATE',
      VIEW: 'ACCOUNTING.ENTRY_DEFERRED.SUBTITLE.VIEW',
    },
    COLUMN: {
      DEFERRED_AMOUNT: 'ACCOUNTING.ENTRY_DEFERRED.COLUMN.DEFERRED_AMOUNT', //Valor Diferido
    },
    DEFERRED_MONTH_TABLE: {
      COLUMN: {
        DOCUMENT: 'ACCOUNTING.ENTRY_DEFERRED.COUNTER.LABEL_SINGULAR',
        DEBIT_ACCOUNT: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.DEBIT_ACCOUNT', // Cuenta Débito, Debit account

        CREDIT_ACCOUNT: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.CREDIT_ACCOUNT', // Cuenta Crédito, Credit account

        IDENTIFICATION_NUMBER:
          'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.IDENTIFICATION_NUMBER', // N. Identificación, Identification number

        NAME_OR_BUSINESS_NAME:
          'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.NAME_OR_BUSINESS_NAME', // Nombre o Razón Social, Name or business name

        COST_CENTER: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.COST_CENTER', // Centro de Costos, Cost center

        DEBIT_VALUE: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.DEBIT_VALUE', // Valor Débito, Debit value

        CREDIT_VALUE: 'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.CREDIT_VALUE', // Valor Crédito, Credit value
      },
    },
  },
  //TERCEROS
  // La ventana que importa un asiento desde un archivo: sus columnas se pintaban en
  // español fijo (Mantis #283).
  IMPORT_ENTRY: {
    COLUMN: {
      ACCOUNT_CODE: 'ACCOUNTING.IMPORT_ENTRY.COLUMN.ACCOUNT_CODE',
      DEBIT_VALUE: 'ACCOUNTING.IMPORT_ENTRY.COLUMN.DEBIT_VALUE',
      CREDIT_VALUE: 'ACCOUNTING.IMPORT_ENTRY.COLUMN.CREDIT_VALUE',
      DEDUCTION_BASE: 'ACCOUNTING.IMPORT_ENTRY.COLUMN.DEDUCTION_BASE',
      IDENTIFICATION: 'ACCOUNTING.IMPORT_ENTRY.COLUMN.IDENTIFICATION',
    },
    ACTION: {
      DELETE_LINE: 'ACCOUNTING.IMPORT_ENTRY.ACTION.DELETE_LINE',
    },
    TABLE: {
      CAPTION: 'ACCOUNTING.IMPORT_ENTRY.TABLE.CAPTION',
    },
    TITLE: 'ACCOUNTING.IMPORT_ENTRY.TITLE',
    STEP: {
      VALIDATE: 'ACCOUNTING.IMPORT_ENTRY.STEP.VALIDATE',
      PROCESS: 'ACCOUNTING.IMPORT_ENTRY.STEP.PROCESS',
    },
    SECTION: {
      FROM_FILE: 'ACCOUNTING.IMPORT_ENTRY.SECTION.FROM_FILE',
    },
    SUMMARY: {
      LINES: 'ACCOUNTING.IMPORT_ENTRY.SUMMARY.LINES',
    },
    PROCESSING: {
      TITLE: 'ACCOUNTING.IMPORT_ENTRY.PROCESSING.TITLE',
      PROGRESS: 'ACCOUNTING.IMPORT_ENTRY.PROCESSING.PROGRESS',
      LINES_TO_PROCESS: 'ACCOUNTING.IMPORT_ENTRY.PROCESSING.LINES_TO_PROCESS',
    },
    ERROR: {
      INVALID_COLUMNS: 'ACCOUNTING.IMPORT_ENTRY.ERROR.INVALID_COLUMNS',
    },
  },

  THIRD_PARTY: {
    // ============================================================
    // 1. Claves de tabla y columnas
    // ============================================================
    COLUMNS: {
      STATUS: 'ACCOUNTING.THIRD_PARTY.COLUMNS.STATUS',
    },
    TABLE: {
      FULL_NAME: {
        FULL_NAME: 'ACCOUNTING.THIRD_PARTY.TABLE.FULL_NAME',
      },
      VINCULOS: {
        TYPE: 'ACCOUNTING.THIRD_PARTY.TABLE.VINCULOS.TYPE',
        REGISTRATION_DATE: 'ACCOUNTING.THIRD_PARTY.TABLE.VINCULOS.REGISTRATION_DATE',
        CONTRALORIA_CODE: 'ACCOUNTING.THIRD_PARTY.TABLE.VINCULOS.CONTRALORIA_CODE',
        SUP_BANCARIA_CODE: 'ACCOUNTING.THIRD_PARTY.TABLE.VINCULOS.SUP_BANCARIA_CODE',
      },
      BANK_ACCOUNTS: {
        BANK: 'ACCOUNTING.THIRD_PARTY.TABLE.BANK_ACCOUNTS.BANK',
        ACCOUNT_TYPE: 'ACCOUNTING.THIRD_PARTY.TABLE.BANK_ACCOUNTS.ACCOUNT_TYPE',
        ACCOUNT_NUMBER: 'ACCOUNTING.THIRD_PARTY.TABLE.BANK_ACCOUNTS.ACCOUNT_NUMBER',
      },
    },

    // ============================================================
    // 2. Títulos y subtítulos
    // ============================================================
    TITLE: {
      LIST: 'ACCOUNTING.THIRD_PARTY.TITLE.LIST',
      CREATE: 'ACCOUNTING.THIRD_PARTY.TITLE.CREATE',
      EDIT: 'ACCOUNTING.THIRD_PARTY.TITLE.EDIT',
      VIEW: 'ACCOUNTING.THIRD_PARTY.TITLE.VIEW',
    },
    SUBTITLE: {
      LIST: 'ACCOUNTING.THIRD_PARTY.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.THIRD_PARTY.SUBTITLE.CREATE',
      EDIT: 'ACCOUNTING.THIRD_PARTY.SUBTITLE.EDIT',
      VIEW: 'ACCOUNTING.THIRD_PARTY.SUBTITLE.VIEW',
      TAX_OBLIGATIONS_INFORMATION: 'ACCOUNTING.THIRD_PARTY.SUBTITLE.TAX_OBLIGATIONS_INFORMATION',
    },

    // ============================================================
    // 3. Formulario - Labels generales
    // ============================================================
    FORM: {
      DOCUMENT_NUMBER: 'ACCOUNTING.THIRD_PARTY.FORM.DOCUMENT_NUMBER',
      DOCUMENT_TYPE: 'ACCOUNTING.THIRD_PARTY.FORM.DOCUMENT_TYPE',
      FULL_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.FULL_NAME',
      GENERAL_DATA: 'ACCOUNTING.THIRD_PARTY.FORM.GENERAL_DATA',
      DV: 'ACCOUNTING.THIRD_PARTY.FORM.DV',
      DV_AUTO: 'ACCOUNTING.THIRD_PARTY.FORM.DV_AUTO',
      PERSON_TYPE: 'ACCOUNTING.THIRD_PARTY.FORM.PERSON_TYPE',
      // El formulario ya rotulaba el estado con la clave comun. Se respeta la suya.
      STATUS: 'COMMON.STATUS',
      FIRST_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.FIRST_NAME',
      SECOND_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.SECOND_NAME',
      FIRST_SURNAME: 'ACCOUNTING.THIRD_PARTY.FORM.FIRST_SURNAME',
      SECOND_SURNAME: 'ACCOUNTING.THIRD_PARTY.FORM.SECOND_SURNAME',
      BUSINESS_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.BUSINESS_NAME',
      ADDRESS: 'ACCOUNTING.THIRD_PARTY.FORM.ADDRESS',
      COUNTRY: 'ACCOUNTING.THIRD_PARTY.FORM.COUNTRY',
      // El departamento ya se rotulaba con la clave del maestro de ciudades. Se respeta.
      DEPARTMENT: 'ACCOUNTING.CITY.FORM.DEPARTMENT',
      CITY: 'ACCOUNTING.THIRD_PARTY.FORM.CITY',
      PHONE: 'ACCOUNTING.THIRD_PARTY.FORM.PHONE',
      MOBILE: 'ACCOUNTING.THIRD_PARTY.FORM.MOBILE',
      EMAIL: 'ACCOUNTING.THIRD_PARTY.FORM.EMAIL',
      TAX_DATA: 'ACCOUNTING.THIRD_PARTY.FORM.TAX_DATA',
      TAX_REGIME: 'ACCOUNTING.THIRD_PARTY.FORM.TAX_REGIME',
      ECONOMIC_ACTIVITY_CODE: 'ACCOUNTING.THIRD_PARTY.FORM.ECONOMIC_ACTIVITY_CODE',
      ECONOMIC_ACTIVITY_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.ECONOMIC_ACTIVITY_NAME',
      AUTO_WITHHOLDING_INCOME: 'ACCOUNTING.THIRD_PARTY.FORM.AUTO_WITHHOLDING_INCOME',
      AUTO_WITHHOLDING_ICA: 'ACCOUNTING.THIRD_PARTY.FORM.AUTO_WITHHOLDING_ICA',
      MAJOR_CONTRIBUTOR: 'ACCOUNTING.THIRD_PARTY.FORM.MAJOR_CONTRIBUTOR',
      NOT_OBLIGED_TO_INVOICE: 'ACCOUNTING.THIRD_PARTY.FORM.NOT_OBLIGED_TO_INVOICE',
      VINCULOS: 'ACCOUNTING.THIRD_PARTY.FORM.VINCULOS',
      BANK_ACCOUNTS: 'ACCOUNTING.THIRD_PARTY.FORM.BANK_ACCOUNTS',
      OTHER_DATA: 'ACCOUNTING.THIRD_PARTY.FORM.OTHER_DATA',
      // Tributarios se reparte en DOS tarjetas: lo que CLASIFICA al tercero ante la
      // DIAN, y las MARCAS que cambian el calculo de sus retenciones. Iban corridas
      // en un solo bloque y nada decia para que servia cada cosa.
      TAX_CLASSIFICATION: 'ACCOUNTING.THIRD_PARTY.FORM.TAX_CLASSIFICATION',
      TAX_CLASSIFICATION_SUBTITLE: 'ACCOUNTING.THIRD_PARTY.FORM.TAX_CLASSIFICATION_SUBTITLE',
      SPECIAL_MARKS: 'ACCOUNTING.THIRD_PARTY.FORM.SPECIAL_MARKS',
      SPECIAL_MARKS_SUBTITLE: 'ACCOUNTING.THIRD_PARTY.FORM.SPECIAL_MARKS_SUBTITLE',
      SPECIAL_MARKS_NONE: 'ACCOUNTING.THIRD_PARTY.FORM.SPECIAL_MARKS_NONE',
      CEDULA_REPRESENTANTE: 'ACCOUNTING.THIRD_PARTY.FORM.CEDULA_REPRESENTANTE',
      NOMBRE_REPRESENTANTE: 'ACCOUNTING.THIRD_PARTY.FORM.NOMBRE_REPRESENTANTE',
      TARJETA_PROFESIONAL: 'ACCOUNTING.THIRD_PARTY.FORM.TARJETA_PROFESIONAL',
      OBSERVACIONES: 'ACCOUNTING.THIRD_PARTY.FORM.OBSERVACIONES',
      // Rotulos de las TARJETAS en que se reparte el formulario. Nacen con la distribucion
      // declarativa: antes los campos iban corridos y no habia nada que rotular.
      IDENTIFICATION: 'ACCOUNTING.THIRD_PARTY.FORM.IDENTIFICATION',
      NAMES: 'ACCOUNTING.THIRD_PARTY.FORM.NAMES',
      LOCATION: 'ACCOUNTING.THIRD_PARTY.FORM.LOCATION',
      CONTACT: 'ACCOUNTING.THIRD_PARTY.FORM.CONTACT',
      LEGAL_REPRESENTATIVE: 'ACCOUNTING.THIRD_PARTY.FORM.LEGAL_REPRESENTATIVE',
      PLACEHOLDER: {
        COUNTRY: 'ACCOUNTING.THIRD_PARTY.FORM.PLACEHOLDER.COUNTRY',
        DEPARTMENT: 'ACCOUNTING.CITY.FORM.PLACEHOLDER.DEPARTMENT',
        CITY: 'ACCOUNTING.THIRD_PARTY.FORM.PLACEHOLDER.CITY',
        ECONOMIC_ACTIVITY_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.PLACEHOLDER.ECONOMIC_ACTIVITY_NAME',
        TAX_REGIME: 'ACCOUNTING.THIRD_PARTY.FORM.PLACEHOLDER.TAX_REGIME',
      },
      TOOLTIP: {
        DV: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.DV',
        CEDULA_REPRESENTANTE: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.CEDULA_REPRESENTANTE',
        NOMBRE_REPRESENTANTE: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.NOMBRE_REPRESENTANTE',
        // Los que GOBIERNAN la captura: de lo que se elija aqui depende lo que se pida
        // despues, y dos de ellos no se pueden deshacer una vez creado el tercero.
        DOCUMENT_TYPE: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.DOCUMENT_TYPE',
        DOCUMENT_NUMBER: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.DOCUMENT_NUMBER',
        PERSON_TYPE: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.PERSON_TYPE',
        TAX_REGIME: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.TAX_REGIME',
        STATUS: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.STATUS',
        // El resto de los campos que se capturan. El texto de todos ellos ya estaba
        // cargado en los dos idiomas y en los dos ambientes: lo que faltaba era
        // declararlo aqui y pedirlo en la distribucion.
        FIRST_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.FIRST_NAME',
        SECOND_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.SECOND_NAME',
        FIRST_SURNAME: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.FIRST_SURNAME',
        SECOND_SURNAME: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.SECOND_SURNAME',
        BUSINESS_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.BUSINESS_NAME',
        COUNTRY: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.COUNTRY',
        // El ROTULO del departamento sigue saliendo del maestro de ciudades, pero su
        // AYUDA no: alli se explica desde la ciudad -«departamento al que pertenece
        // la ciudad»- y aqui se diligencia al reves, del pais hacia la ciudad.
        DEPARTMENT: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.DEPARTMENT',
        CITY: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.CITY',
        ADDRESS: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.ADDRESS',
        PHONE: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.PHONE',
        MOBILE: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.MOBILE',
        EMAIL: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.EMAIL',
        TARJETA_PROFESIONAL: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.TARJETA_PROFESIONAL',
        OBSERVACIONES: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.OBSERVACIONES',
        ECONOMIC_ACTIVITY_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.ECONOMIC_ACTIVITY_NAME',
        ECONOMIC_ACTIVITY_CODE: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.ECONOMIC_ACTIVITY_CODE',
      },
      // Notas de uso al pie del campo: dicen PARA QUE sirve el dato, no como se escribe.
      HINT: {
        DV: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.DV',
        TAX_REGIME: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.TAX_REGIME',
        ECONOMIC_ACTIVITY_CODE: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.ECONOMIC_ACTIVITY_CODE',
        // Cada bandera dice QUE CAMBIA al ponerla: el rotulo la nombra, la nota la explica.
        AUTO_WITHHOLDING_INCOME: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.AUTO_WITHHOLDING_INCOME',
        AUTO_WITHHOLDING_ICA: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.AUTO_WITHHOLDING_ICA',
        MAJOR_CONTRIBUTOR: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.MAJOR_CONTRIBUTOR',
        NOT_OBLIGED_TO_INVOICE: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.NOT_OBLIGED_TO_INVOICE',
        LEGAL_REPRESENTATIVE_NAME: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.LEGAL_REPRESENTATIVE_NAME',
        PROFESSIONAL_CARD: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.PROFESSIONAL_CARD',
        OBSERVATIONS: 'ACCOUNTING.THIRD_PARTY.FORM.HINT.OBSERVATIONS',
      },
      // Panel que acompaña a la captura. El resumen y lo que falta los compone el motor.
      PANEL: {
        SUMMARY: 'ACCOUNTING.THIRD_PARTY.FORM.PANEL.SUMMARY',
        SUMMARY_TITLE_EMPTY: 'ACCOUNTING.THIRD_PARTY.FORM.PANEL.SUMMARY_TITLE_EMPTY',
        SUMMARY_CODE_EMPTY: 'ACCOUNTING.THIRD_PARTY.FORM.PANEL.SUMMARY_CODE_EMPTY',
        SUMMARY_FOOT_EMPTY: 'ACCOUNTING.THIRD_PARTY.FORM.PANEL.SUMMARY_FOOT_EMPTY',
        CHECKLIST: 'ACCOUNTING.THIRD_PARTY.FORM.PANEL.CHECKLIST',
        USAGE: 'ACCOUNTING.THIRD_PARTY.FORM.PANEL.USAGE',
        USAGE_HINT: 'ACCOUNTING.THIRD_PARTY.FORM.PANEL.USAGE_HINT',
      },
    },

    // ============================================================
    // 4. Placeholders, empty state y search
    // ============================================================
    SEARCH_PLACEHOLDER: 'ACCOUNTING.THIRD_PARTY.SEARCH_PLACEHOLDER',
    EMPTY: {
      MESSAGE: 'ACCOUNTING.THIRD_PARTY.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.THIRD_PARTY.EMPTY.DESCRIPTION',
    },

    // ============================================================
    // 5. Opciones de selects
    // ============================================================
    OPTIONS: {
      DOCUMENT_TYPE: {
        CC: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.CC',
        RC: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.RC',
        TI: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.TI',
        PP: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.PP',
        NIT: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.NIT',
        CE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.CE',
        PEP: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.PEP',
        IE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.IE',
      },
      PERSON_TYPE: {
        NATURAL: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.PERSON_TYPE.NATURAL',
        JURIDICA: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.PERSON_TYPE.JURIDICA',
      },
      LINK_TYPE: {
        PROVEEDOR: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.PROVEEDOR',
        CLIENTE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.CLIENTE',
        EMPLEADO: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.EMPLEADO',
        ENTIDAD_PUBLICA: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.ENTIDAD_PUBLICA',
        ENTIDAD_BANCARIA: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.ENTIDAD_BANCARIA',
      },
      ACCOUNT_TYPE: {
        CORRIENTE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.CORRIENTE',
        AHORROS: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.AHORROS',
        DEPOSITO_ELECTRONICO:
          'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.DEPOSITO_ELECTRONICO',
        PENSIONADO: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.PENSIONADO',
      },
      TAX_REGIME: {
        ORDINARIO: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.ORDINARIO',
        SIMPLE: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.SIMPLE',
        ESPECIAL: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.ESPECIAL',
        NO_RESPONSABLE_IVA: 'ACCOUNTING.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.NO_RESPONSABLE_IVA',
      },
      SELECT_ECONOMIC_ACTIVITY: 'ACCOUNTING.THIRD_PARTY.OPTIONS.SELECT_ECONOMIC_ACTIVITY',
    },

    // ============================================================
    // 6. Mensajes (éxito, advertencia, error)
    // ============================================================
    MESSAGES: {
      SUCCESS: {
        CREATE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.SUCCESS.CREATE',
        UPDATE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.SUCCESS.UPDATE',
        DELETE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.SUCCESS.DELETE',
      },
      WARNING: {
        REQUIRED_FIELDS: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.REQUIRED_FIELDS',
        NO_VINCULOS: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.NO_VINCULOS',
        DUPLICATE_VINCULO: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.DUPLICATE_VINCULO',
        UNIQUE_ACTIVE_ACCOUNT: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.UNIQUE_ACTIVE_ACCOUNT',
        DELETE_ONLY_INACTIVE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.DELETE_ONLY_INACTIVE',
        INACTIVE_NOT_EDITABLE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.INACTIVE_NOT_EDITABLE',
        DOCUMENT_IMMUTABLE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.WARNING.DOCUMENT_IMMUTABLE',
      },
      ERROR: {
        LOAD: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.LOAD',
        CREATE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.CREATE',
        UPDATE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.UPDATE',
        DELETE: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.DELETE',
        LOAD_DETAIL: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ERROR.LOAD_DETAIL',
        DUPLICATE_DOCUMENT_NUMBER: 'ACCOUNTING.THIRD_PARTY.ERRORS.DUPLICATE_DOCUMENT_NUMBER',

        INVALID_VERIFICATION_DIGIT: 'ACCOUNTING.THIRD_PARTY.ERRORS.INVALID_VERIFICATION_DIGIT',
        INVALID_VERIFICATION_DIGIT_FORMAT:
          'ACCOUNTING.THIRD_PARTY.ERRORS.INVALID_VERIFICATION_DIGIT_FORMAT',
      },
      INCOMPLETE_INFORMATION: 'ACCOUNTING.THIRD_PARTY.MESSAGES.INCOMPLETE_INFORMATION',
      PARTS_SEPARATOR: 'ACCOUNTING.THIRD_PARTY.MESSAGES.PARTS_SEPARATOR',
      INCOMPLETE_INFORMATION_CONFIRMATION:
        'ACCOUNTING.THIRD_PARTY.MESSAGES.INCOMPLETE_INFORMATION_CONFIRMATION',
      COMPLETE_REQUIRED_FIELDS: 'ACCOUNTING.THIRD_PARTY.MESSAGES.COMPLETE_REQUIRED_FIELDS',
      ADD_AT_LEAST_ONE_LINK: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ADD_AT_LEAST_ONE_LINK',

      THIRD_PARTY_DETAILS_LOAD_ERROR:
        'ACCOUNTING.THIRD_PARTY.MESSAGES.THIRD_PARTY_DETAILS_LOAD_ERROR',
      SELECT_COUNTRY_FIRST: 'ACCOUNTING.THIRD_PARTY.MESSAGES.SELECT_COUNTRY_FIRST',
      SELECT_DEPARTMENT_FIRST: 'ACCOUNTING.THIRD_PARTY.MESSAGES.SELECT_DEPARTMENT_FIRST',
      COUNTRY_SELECTED: 'ACCOUNTING.THIRD_PARTY.MESSAGES.COUNTRY_SELECTED',

      COUNTRY_SEARCH_ERROR: 'ACCOUNTING.THIRD_PARTY.MESSAGES.COUNTRY_SEARCH_ERROR',

      ECONOMIC_ACTIVITY_SELECTED: 'ACCOUNTING.THIRD_PARTY.MESSAGES.ECONOMIC_ACTIVITY_SELECTED',

      ECONOMIC_ACTIVITY_SEARCH_ERROR:
        'ACCOUNTING.THIRD_PARTY.MESSAGES.ECONOMIC_ACTIVITY_SEARCH_ERROR',

      DEPARTMENT_SELECTED: 'ACCOUNTING.THIRD_PARTY.MESSAGES.DEPARTMENT_SELECTED',

      DEPARTMENT_SEARCH_ERROR: 'ACCOUNTING.THIRD_PARTY.MESSAGES.DEPARTMENT_SEARCH_ERROR',

      CITY_SELECTED: 'ACCOUNTING.THIRD_PARTY.MESSAGES.CITY_SELECTED',

      CITY_SEARCH_ERROR: 'ACCOUNTING.THIRD_PARTY.MESSAGES.CITY_SEARCH_ERROR',

      LINK_ALREADY_EXISTS: 'ACCOUNTING.THIRD_PARTY.MESSAGES.LINK_ALREADY_EXISTS',
    },

    // ============================================================
    // 7. Validaciones
    // ============================================================
    VALIDATION: {
      FIELD: {
        DOCUMENT_TYPE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.DOCUMENT_TYPE',
        DOCUMENT_NUMBER: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.DOCUMENT_NUMBER',
        PERSON_TYPE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.PERSON_TYPE',
        FIRST_NAME: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.FIRST_NAME',
        FIRST_SURNAME: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.FIRST_SURNAME',
        BUSINESS_NAME: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.BUSINESS_NAME',
        ADDRESS: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.ADDRESS',
        COUNTRY: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.COUNTRY',
        CITY: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.CITY',
        PHONE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.PHONE',
        MOBILE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.MOBILE',
        EMAIL: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.EMAIL',
        ECONOMIC_ACTIVITY_CODE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.ECONOMIC_ACTIVITY_CODE',
        DV: 'ACCOUNTING.THIRD_PARTY.VALIDATION.FIELD.DV',
      },
      EMAIL_INVALID: 'ACCOUNTING.THIRD_PARTY.VALIDATION.EMAIL_INVALID',
      DV_INVALID: 'ACCOUNTING.THIRD_PARTY.VALIDATION.DV_INVALID',
      DUPLICATE_DOCUMENT: 'ACCOUNTING.THIRD_PARTY.VALIDATION.DUPLICATE_DOCUMENT',
      PATTERN: {
        DOCUMENT_NUMBER: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.DOCUMENT_NUMBER',
        NAME: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.NAME',
        DV: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.DV',
        PHONE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.PHONE',
        ECONOMIC_ACTIVITY_CODE: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.ECONOMIC_ACTIVITY_CODE',
        DEFAULT: 'ACCOUNTING.THIRD_PARTY.VALIDATION.PATTERN.DEFAULT',
      },
    },

    // ============================================================
    // 8. Diálogos de confirmación
    // ============================================================
    DIALOG: {
      DELETE: {
        TITLE: 'ACCOUNTING.THIRD_PARTY.DIALOG.DELETE.TITLE',
        MESSAGE: 'ACCOUNTING.THIRD_PARTY.DIALOG.DELETE.MESSAGE',
        CONFIRM_LABEL: 'ACCOUNTING.THIRD_PARTY.DIALOG.DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACCOUNTING.THIRD_PARTY.DIALOG.DELETE.CANCEL_LABEL',
      },
    },
    SECTIONS: {
      BANK_ACCOUNTS: 'ACCOUNTING.THIRD_PARTY.SECTIONS.BANK_ACCOUNTS',
      OTHER_DATA: 'ACCOUNTING.THIRD_PARTY.SECTIONS.OTHER_DATA',
    },

    // ============================================================
    // Vinculos del tercero (CRUD anidado)
    // ============================================================
    VINCULOS: {
      FORM: {
        SECTION: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.SECTION',
        HINT: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.HINT',
        LINK_TYPE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.LINK_TYPE',
        CONTRALORIA_CODE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.CONTRALORIA_CODE',
        SUP_BANCARIA_CODE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.SUP_BANCARIA_CODE',
        SUP_BANCARIA_CODE_2: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.SUP_BANCARIA_CODE_2',
        SUB_BANCARIA_NAME_2: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.SUB_BANCARIA_NAME_2',
        PLACEHOLDER: {
          LINK_TYPE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.LINK_TYPE',
          CONTRALORIA_CODE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.CONTRALORIA_CODE',
          SUP_BANCARIA_CODE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.SUP_BANCARIA_CODE',
          SUP_BANCARIA_CODE_2:
            'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.SUP_BANCARIA_CODE_2',
          SUB_BANCARIA_NAME_2:
            'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.SUB_BANCARIA_NAME_2',
        },
        TOOLTIP: {
          LINK_TYPE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.LINK_TYPE',
          CONTRALORIA_CODE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.CONTRALORIA_CODE',
          SUP_BANCARIA_CODE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.SUP_BANCARIA_CODE',
          SUP_BANCARIA_CODE_2: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.SUP_BANCARIA_CODE_2',
          SUB_BANCARIA_NAME_2: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.SUB_BANCARIA_NAME_2',
        },
      },
    },

    // ============================================================
    // Cuentas bancarias del tercero (CRUD anidado)
    // ============================================================
    // La ventana que busca la actividad economica. Tiene claves PROPIAS y no toma prestadas
    // las del campo: en el formulario el rotulo es «Actividad economica (CIIU)» porque alli
    // identifica el dato entero, y en una tabla de dos columnas lo que se lee es «Codigo» y
    // «Nombre».
    ECONOMIC_ACTIVITY_MODAL: {
      TITLE: 'ACCOUNTING.THIRD_PARTY.ECONOMIC_ACTIVITY_MODAL.TITLE',
      COLUMN: {
        CODE: 'ACCOUNTING.THIRD_PARTY.ECONOMIC_ACTIVITY_MODAL.COLUMN.CODE',
        NAME: 'ACCOUNTING.THIRD_PARTY.ECONOMIC_ACTIVITY_MODAL.COLUMN.NAME',
      },
      PLACEHOLDER: {
        SEARCH: 'ACCOUNTING.THIRD_PARTY.ECONOMIC_ACTIVITY_MODAL.PLACEHOLDER.SEARCH',
      },
    },

    CUENTAS_BANCO: {
      FORM: {
        SECTION: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.SECTION',
        BANK: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.BANK',
        ACCOUNT_TYPE: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.ACCOUNT_TYPE',
        ACCOUNT_NUMBER: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.ACCOUNT_NUMBER',
        BRE_B: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.BRE_B',
        STATUS: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.STATUS',
        HINT: {
          BRE_B: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.HINT.BRE_B',
          STATUS: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.HINT.STATUS',
        },
        PLACEHOLDER: {
          BANK: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.PLACEHOLDER.BANK',
          ACCOUNT_TYPE: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.PLACEHOLDER.ACCOUNT_TYPE',
          ACCOUNT_NUMBER: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.PLACEHOLDER.ACCOUNT_NUMBER',
          BRE_B: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.PLACEHOLDER.BRE_B',
          STATUS: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.PLACEHOLDER.STATUS',
        },
        TOOLTIP: {
          BANK: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.TOOLTIP.BANK',
          ACCOUNT_TYPE: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.TOOLTIP.ACCOUNT_TYPE',
          ACCOUNT_NUMBER: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.TOOLTIP.ACCOUNT_NUMBER',
          BRE_B: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.TOOLTIP.BRE_B',
          STATUS: 'ACCOUNTING.THIRD_PARTY.CUENTAS_BANCO.FORM.TOOLTIP.STATUS',
        },
      },
    },
    ACTIONS: {
      FINISH: 'ACCOUNTING.THIRD_PARTY.ACTIONS.FINISH',
      CANCEL: 'ACCOUNTING.THIRD_PARTY.ACTIONS.CANCEL',
    },
  },

  // ============================================================
  // Tasas de Cambio (HT_CON_017)
  // ============================================================
  EXCHANGE_RATE: {
    TITLE: {
      // Tasas de Cambio
      LIST: 'ACCOUNTING.EXCHANGE_RATE.TITLE.LIST',
      CREATE: 'ACCOUNTING.EXCHANGE_RATE.TITLE.CREATE',
      EDIT: 'ACCOUNTING.EXCHANGE_RATE.TITLE.EDIT',
      VIEW: 'ACCOUNTING.EXCHANGE_RATE.TITLE.VIEW',
    },

    SUBTITLE: {
      LIST: 'ACCOUNTING.EXCHANGE_RATE.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.EXCHANGE_RATE.SUBTITLE.CREATE',
      EDIT: 'ACCOUNTING.EXCHANGE_RATE.SUBTITLE.EDIT',
      VIEW: 'ACCOUNTING.EXCHANGE_RATE.SUBTITLE.VIEW',
    },

    // Lo que la grilla declarativa compone con el prefijo de la pantalla.
    // Buscar por moneda o estado...
    SEARCH_PLACEHOLDER: 'ACCOUNTING.EXCHANGE_RATE.SEARCH_PLACEHOLDER',

    COUNTER: {
      // tasa de cambio / tasas de cambio
      SINGULAR: 'ACCOUNTING.EXCHANGE_RATE.COUNTER.SINGULAR',
      PLURAL: 'ACCOUNTING.EXCHANGE_RATE.COUNTER.PLURAL',
    },

    EMPTY: {
      MESSAGE: 'ACCOUNTING.EXCHANGE_RATE.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.EXCHANGE_RATE.EMPTY.DESCRIPTION',
    },

    SAVE: {
      CONFIRM_TITLE: 'ACCOUNTING.EXCHANGE_RATE.SAVE.CONFIRM_TITLE',
      CONFIRM_MESSAGE: 'ACCOUNTING.EXCHANGE_RATE.SAVE.CONFIRM_MESSAGE',
    },

    FORM: {
      TOOLTIP: {
        CURRENCY: 'ACCOUNTING.EXCHANGE_RATE.FORM.TOOLTIP.CURRENCY',
        DATE: 'ACCOUNTING.EXCHANGE_RATE.FORM.TOOLTIP.DATE',
        VALUE: 'ACCOUNTING.EXCHANGE_RATE.FORM.TOOLTIP.VALUE',
        STATUS: 'ACCOUNTING.EXCHANGE_RATE.FORM.TOOLTIP.STATUS',
      },
      PLACEHOLDER: {
        CURRENCY: 'ACCOUNTING.EXCHANGE_RATE.FORM.PLACEHOLDER.CURRENCY',
        VALUE: 'ACCOUNTING.EXCHANGE_RATE.FORM.PLACEHOLDER.VALUE',
        STATUS: 'ACCOUNTING.EXCHANGE_RATE.FORM.PLACEHOLDER.STATUS',
      },
    },

    VALIDATION: {
      REQUIRED: 'ACCOUNTING.EXCHANGE_RATE.VALIDATION.REQUIRED',
      VALUE_MIN: 'ACCOUNTING.EXCHANGE_RATE.VALIDATION.VALUE_MIN',
      DATE_FUTURE: 'ACCOUNTING.EXCHANGE_RATE.VALIDATION.DATE_FUTURE',
      DATE_MIN: 'ACCOUNTING.EXCHANGE_RATE.VALIDATION.DATE_MIN',
      DATE_DUPLICATE: 'ACCOUNTING.EXCHANGE_RATE.VALIDATION.DATE_DUPLICATE',
    },

    MESSAGES: {
      NO_DATA_TO_EXPORT: 'ACCOUNTING.EXCHANGE_RATE.MESSAGES.NO_DATA_TO_EXPORT',
      EXPORT_SUCCESS: 'ACCOUNTING.EXCHANGE_RATE.MESSAGES.EXPORT_SUCCESS',
      EXPORT_EMPTY: 'ACCOUNTING.EXCHANGE_RATE.MESSAGES.EXPORT_EMPTY',
      EXPORT_ERROR: 'ACCOUNTING.EXCHANGE_RATE.MESSAGES.EXPORT_ERROR',
      EXPORT_ERROR_TITLE: 'ACCOUNTING.EXCHANGE_RATE.MESSAGES.EXPORT_ERROR_TITLE',
    },

    EXPORT: {
      // Nombre con el que se descarga el archivo. Estaba escrito en español dentro del
      // codigo ("TasasDeCambio"), de modo que el archivo salia igual en cualquier idioma.
      FILENAME: 'ACCOUNTING.EXCHANGE_RATE.EXPORT.FILENAME',
    },
  },

  // ============================================================
  // Maestro de Monedas (HT_CON_017)
  // ============================================================
  CURRENCY: {
    TITLE: {
      // Monedas
      LIST: 'ACCOUNTING.CURRENCY.TITLE.LIST',

      // Nueva Moneda
      CREATE: 'ACCOUNTING.CURRENCY.TITLE.CREATE',

      // Editar Moneda
      EDIT: 'ACCOUNTING.CURRENCY.TITLE.EDIT',

      // Consultar Moneda
      VIEW: 'ACCOUNTING.CURRENCY.TITLE.VIEW',
    },

    SUBTITLE: {
      LIST: 'ACCOUNTING.CURRENCY.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.CURRENCY.SUBTITLE.CREATE',
      EDIT: 'ACCOUNTING.CURRENCY.SUBTITLE.EDIT',
      VIEW: 'ACCOUNTING.CURRENCY.SUBTITLE.VIEW',
    },

    // Lo que la grilla declarativa compone con el prefijo de la pantalla.
    // Buscar por código, descripción o símbolo...
    SEARCH_PLACEHOLDER: 'ACCOUNTING.CURRENCY.SEARCH_PLACEHOLDER',

    COUNTER: {
      // moneda / monedas
      SINGULAR: 'ACCOUNTING.CURRENCY.COUNTER.SINGULAR',
      PLURAL: 'ACCOUNTING.CURRENCY.COUNTER.PLURAL',
    },

    EMPTY: {
      MESSAGE: 'ACCOUNTING.CURRENCY.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.CURRENCY.EMPTY.DESCRIPTION',
    },

    COLUMNS: {
      // Tasas
      RATES: 'ACCOUNTING.CURRENCY.COLUMNS.RATES',

      // De operación
      OPERATION: 'ACCOUNTING.CURRENCY.COLUMNS.OPERATION',
    },

    ACTIONS: {
      // Designar como moneda de operación
      SET_OPERATION: 'ACCOUNTING.CURRENCY.ACTIONS.SET_OPERATION',

      // Quitar la moneda de operación
      UNSET_OPERATION: 'ACCOUNTING.CURRENCY.ACTIONS.UNSET_OPERATION',
    },

    OPERATION: {
      SET_TITLE: 'ACCOUNTING.CURRENCY.OPERATION.SET_TITLE',
      SET_MESSAGE: 'ACCOUNTING.CURRENCY.OPERATION.SET_MESSAGE',
      UNSET_TITLE: 'ACCOUNTING.CURRENCY.OPERATION.UNSET_TITLE',
      UNSET_MESSAGE: 'ACCOUNTING.CURRENCY.OPERATION.UNSET_MESSAGE',
    },

    SAVE: {
      CONFIRM_TITLE: 'ACCOUNTING.CURRENCY.SAVE.CONFIRM_TITLE',
      CONFIRM_MESSAGE: 'ACCOUNTING.CURRENCY.SAVE.CONFIRM_MESSAGE',
    },

    FORM: {
      TOOLTIP: {
        CODE: 'ACCOUNTING.CURRENCY.FORM.TOOLTIP.CODE',
        DESCRIPTION: 'ACCOUNTING.CURRENCY.FORM.TOOLTIP.DESCRIPTION',
        SYMBOL: 'ACCOUNTING.CURRENCY.FORM.TOOLTIP.SYMBOL',
        DECIMALS: 'ACCOUNTING.CURRENCY.FORM.TOOLTIP.DECIMALS',
        OPERATION: 'ACCOUNTING.CURRENCY.FORM.TOOLTIP.OPERATION',
        STATUS: 'ACCOUNTING.CURRENCY.FORM.TOOLTIP.STATUS',
      },
      PLACEHOLDER: {
        // Seleccione una opción
        STATUS: 'ACCOUNTING.CURRENCY.FORM.PLACEHOLDER.STATUS',
      },
    },

    VALIDATION: {
      REQUIRED: 'ACCOUNTING.CURRENCY.VALIDATION.REQUIRED',
      MAX_LENGTH: 'ACCOUNTING.CURRENCY.VALIDATION.MAX_LENGTH',
      CODE_PATTERN: 'ACCOUNTING.CURRENCY.VALIDATION.CODE_PATTERN',
      MIN: 'ACCOUNTING.CURRENCY.VALIDATION.MIN',
      MAX: 'ACCOUNTING.CURRENCY.VALIDATION.MAX',
    },

    MESSAGES: {
      NO_DATA_TO_EXPORT: 'ACCOUNTING.CURRENCY.MESSAGES.NO_DATA_TO_EXPORT',
      EXPORT_SUCCESS: 'ACCOUNTING.CURRENCY.MESSAGES.EXPORT_SUCCESS',
      EXPORT_EMPTY: 'ACCOUNTING.CURRENCY.MESSAGES.EXPORT_EMPTY',
      EXPORT_ERROR: 'ACCOUNTING.CURRENCY.MESSAGES.EXPORT_ERROR',
      EXPORT_ERROR_TITLE: 'ACCOUNTING.CURRENCY.MESSAGES.EXPORT_ERROR_TITLE',
    },

    EXPORT: {
      // Nombre con el que se descarga el archivo. Estaba escrito en español dentro del
      // codigo ("Monedas"), de modo que el archivo salia igual en cualquier idioma.
      FILENAME: 'ACCOUNTING.CURRENCY.EXPORT.FILENAME',
    },

    DELETE: {
      BLOCKED_TITLE: 'ACCOUNTING.CURRENCY.DELETE.BLOCKED_TITLE',
      HAS_RATES: 'ACCOUNTING.CURRENCY.DELETE.HAS_RATES',
      IS_OPERATION: 'ACCOUNTING.CURRENCY.DELETE.IS_OPERATION',
    },
  },

  // ============================================================
  // Usuarios por Dependencia (HT_CON_029)
  // ============================================================
  USER_DEPENDENCY: {
    TITLE: {
      // Usuarios por Dependencia
      LIST: 'ACCOUNTING.USER_DEPENDENCY.TITLE.LIST',

      // Asignar Usuario a Dependencia
      CREATE: 'ACCOUNTING.USER_DEPENDENCY.TITLE.CREATE',

      // Editar Asignación
      EDIT: 'ACCOUNTING.USER_DEPENDENCY.TITLE.EDIT',

      // Detalle de la Asignación
      VIEW: 'ACCOUNTING.USER_DEPENDENCY.TITLE.VIEW',
    },

    SUBTITLE: {
      // Consulte la asignación de usuarios a dependencias
      LIST: 'ACCOUNTING.USER_DEPENDENCY.SUBTITLE.LIST',

      // Complete la información para asignar un usuario a una dependencia
      CREATE: 'ACCOUNTING.USER_DEPENDENCY.SUBTITLE.CREATE',

      // Modifique la información de la asignación
      EDIT: 'ACCOUNTING.USER_DEPENDENCY.SUBTITLE.EDIT',

      // Detalle completo de la asignación
      VIEW: 'ACCOUNTING.USER_DEPENDENCY.SUBTITLE.VIEW',
    },

    COLUMNS: {
      // Código
      CODE: 'ACCOUNTING.USER_DEPENDENCY.COLUMNS.CODE',

      // Dependencia
      DEPENDENCY: 'ACCOUNTING.USER_DEPENDENCY.COLUMNS.DEPENDENCY',

      // Usuario
      USER: 'ACCOUNTING.USER_DEPENDENCY.COLUMNS.USER',

      // Estado
      STATUS: 'ACCOUNTING.USER_DEPENDENCY.COLUMNS.STATUS',

      // Por defecto
      DEFAULT: 'ACCOUNTING.USER_DEPENDENCY.COLUMNS.DEFAULT',
    },

    // Buscar por código, dependencia o usuario
    SEARCH_PLACEHOLDER: 'ACCOUNTING.USER_DEPENDENCY.SEARCH_PLACEHOLDER',

    MODAL: {
      USER: {
        // Buscar usuario
        TITLE: 'ACCOUNTING.USER_DEPENDENCY.MODAL.USER.TITLE',

        // Buscar por usuario o correo...
        SEARCH: 'ACCOUNTING.USER_DEPENDENCY.MODAL.USER.SEARCH',
      },
    },

    /** Lo que el usuario lee cuando la accion termina: el estado en que quedo la asignacion. */
    RESULT: {
      // La asignación quedó activa.
      ACTIVATED: 'ACCOUNTING.USER_DEPENDENCY.RESULT.ACTIVATED',

      // La asignación quedó inactiva.
      DEACTIVATED: 'ACCOUNTING.USER_DEPENDENCY.RESULT.DEACTIVATED',
    },

    CONFIRM: {
      ACTIVATE: {
        // Activar asignación
        TITLE: 'ACCOUNTING.USER_DEPENDENCY.CONFIRM.ACTIVATE.TITLE',

        // La asignación vuelve a habilitar al usuario en la dependencia.
        MESSAGE: 'ACCOUNTING.USER_DEPENDENCY.CONFIRM.ACTIVATE.MESSAGE',
      },

      INACTIVATE: {
        // Desactivar asignación
        TITLE: 'ACCOUNTING.USER_DEPENDENCY.CONFIRM.INACTIVATE.TITLE',

        // La asignación no se elimina: queda inactiva y deja de habilitar al usuario.
        MESSAGE: 'ACCOUNTING.USER_DEPENDENCY.CONFIRM.INACTIVATE.MESSAGE',
      },
    },

    COUNTER: {
      // asignación
      SINGULAR: 'ACCOUNTING.USER_DEPENDENCY.COUNTER.SINGULAR',

      // asignaciones
      PLURAL: 'ACCOUNTING.USER_DEPENDENCY.COUNTER.PLURAL',
    },

    FORM: {
      // Dependencia
      DEPENDENCY: 'ACCOUNTING.USER_DEPENDENCY.FORM.DEPENDENCY',

      // Usuario
      USER: 'ACCOUNTING.USER_DEPENDENCY.FORM.USER',

      // Seleccione la dependencia a la que se asigna el usuario.
      TOOLTIP: {
        DEPENDENCY: 'ACCOUNTING.USER_DEPENDENCY.FORM.TOOLTIP.DEPENDENCY',
        USER: 'ACCOUNTING.USER_DEPENDENCY.FORM.TOOLTIP.USER',
        STATUS: 'ACCOUNTING.USER_DEPENDENCY.FORM.TOOLTIP.STATUS',
        // La que se preselecciona como contexto del usuario al entrar a Presupuesto. Solo una por usuario.
        DEFAULT: 'ACCOUNTING.USER_DEPENDENCY.FORM.TOOLTIP.DEFAULT',
      },

      // Dependencia por defecto del usuario
      DEFAULT: 'ACCOUNTING.USER_DEPENDENCY.FORM.DEFAULT',

      // Nombre de usuario en Nebula
      USER_PLACEHOLDER: 'ACCOUNTING.USER_DEPENDENCY.FORM.USER_PLACEHOLDER',
    },

    EMPTY: {
      // No se encontraron asignaciones
      MESSAGE: 'ACCOUNTING.USER_DEPENDENCY.EMPTY.MESSAGE',

      // Intente con otro término de búsqueda o retire los filtros.
      DESCRIPTION: 'ACCOUNTING.USER_DEPENDENCY.EMPTY.DESCRIPTION',
    },

    /**
     * Etiquetas del estado del vínculo. Son las claves que sembró la migración `V075` del
     * backend: el listado del enum se traduce con las MISMAS claves con las que el servicio
     * responde, sin una copia paralela en el frontend.
     */
    STATUS_VALUES: {
      ACTIVE: 'accounting.usuariodependencia.estado.activo',
      INACTIVE: 'accounting.usuariodependencia.estado.inactivo',
      DELETED: 'accounting.usuariodependencia.estado.eliminado',
    },
  },
  /**
   * Saldos Contables (`HT_ARQ_006`).
   *
   * Solo las claves que la grilla declarativa consume: el titulo, el subtitulo, las cabeceras, el
   * contador, el texto de la tabla vacia y el marcador del buscador. Los rotulos de los filtros por
   * eje, el formulario de consulta y los avisos del mantenimiento siguen escritos en la pantalla,
   * igual que antes de la conversion.
   */
  BALANCES: {
    TITLE: {
      // Saldos Contables
      LIST: 'ACCOUNTING.BALANCES.TITLE.LIST',

      // Consultar Saldo
      VIEW: 'ACCOUNTING.BALANCES.TITLE.VIEW',
    },

    SUBTITLE: {
      // Saldos por cuenta, tercero, centro de costos y periodo
      LIST: 'ACCOUNTING.BALANCES.SUBTITLE.LIST',

      // Detalle del saldo
      VIEW: 'ACCOUNTING.BALANCES.SUBTITLE.VIEW',
    },

    COLUMNS: {
      // Tipo Plan
      PLAN_TYPE: 'ACCOUNTING.BALANCES.COLUMNS.PLAN_TYPE',

      // Cuenta
      ACCOUNT_CODE: 'ACCOUNTING.BALANCES.COLUMNS.ACCOUNT_CODE',

      // Nombre Cuenta
      ACCOUNT_NAME: 'ACCOUNTING.BALANCES.COLUMNS.ACCOUNT_NAME',

      /**
       * Naturaleza de la cuenta (HT_ARQ_006).
       *
       * Titula la columna, no su contenido: los valores DEBITO y CREDITO se resuelven con las
       * claves DEBIT y CREDIT que esta misma pantalla ya usa para sus columnas de movimiento.
       */
      NATURE: 'ACCOUNTING.BALANCES.COLUMNS.NATURE',

      // NIT
      THIRD_PARTY_ID: 'ACCOUNTING.BALANCES.COLUMNS.THIRD_PARTY_ID',

      // Tercero
      THIRD_PARTY: 'ACCOUNTING.BALANCES.COLUMNS.THIRD_PARTY',

      // Cod. CC
      COST_CENTER_CODE: 'ACCOUNTING.BALANCES.COLUMNS.COST_CENTER_CODE',

      // Centro de Costos
      COST_CENTER: 'ACCOUNTING.BALANCES.COLUMNS.COST_CENTER',

      // Periodo
      PERIOD: 'ACCOUNTING.BALANCES.COLUMNS.PERIOD',

      // Saldo Inicial
      INITIAL_BALANCE: 'ACCOUNTING.BALANCES.COLUMNS.INITIAL_BALANCE',

      // Debito
      DEBIT: 'ACCOUNTING.BALANCES.COLUMNS.DEBIT',

      // Credito
      CREDIT: 'ACCOUNTING.BALANCES.COLUMNS.CREDIT',

      // Saldo Final
      FINAL_BALANCE: 'ACCOUNTING.BALANCES.COLUMNS.FINAL_BALANCE',
    },

    // Buscar por cuenta, tercero, centro de costos o periodo
    SEARCH_PLACEHOLDER: 'ACCOUNTING.BALANCES.SEARCH_PLACEHOLDER',

    COUNTER: {
      // saldo
      SINGULAR: 'ACCOUNTING.BALANCES.COUNTER.SINGULAR',

      // saldos
      PLURAL: 'ACCOUNTING.BALANCES.COUNTER.PLURAL',
    },

    EMPTY: {
      // No hay saldos contables
      MESSAGE: 'ACCOUNTING.BALANCES.EMPTY.MESSAGE',

      // Los saldos se escriben al aprobar la causacion y se reconstruyen desde el mantenimiento.
      DESCRIPTION: 'ACCOUNTING.BALANCES.EMPTY.DESCRIPTION',
    },

    /** Rotulos, ayudas y acciones de la barra de filtros por eje. */
    FILTERS: {
      PLAN_TYPE: {
        // Tipo de plan
        LABEL: 'ACCOUNTING.BALANCES.FILTERS.PLAN_TYPE.LABEL',

        // Plan contable (multiplan)
        TOOLTIP: 'ACCOUNTING.BALANCES.FILTERS.PLAN_TYPE.TOOLTIP',

        // Todos
        ALL: 'ACCOUNTING.BALANCES.FILTERS.PLAN_TYPE.ALL',
      },

      ACCOUNT: {
        // Cuenta
        LABEL: 'ACCOUNTING.BALANCES.FILTERS.ACCOUNT.LABEL',

        // Se elige del plan de cuentas
        TOOLTIP: 'ACCOUNTING.BALANCES.FILTERS.ACCOUNT.TOOLTIP',

        // Codigo
        PLACEHOLDER: 'ACCOUNTING.BALANCES.FILTERS.ACCOUNT.PLACEHOLDER',

        // Buscar cuenta contable
        SEARCH: 'ACCOUNTING.BALANCES.FILTERS.ACCOUNT.SEARCH',
      },

      THIRD_PARTY: {
        // Tercero
        LABEL: 'ACCOUNTING.BALANCES.FILTERS.THIRD_PARTY.LABEL',

        // Se elige del maestro de terceros
        TOOLTIP: 'ACCOUNTING.BALANCES.FILTERS.THIRD_PARTY.TOOLTIP',

        // Identificacion
        PLACEHOLDER: 'ACCOUNTING.BALANCES.FILTERS.THIRD_PARTY.PLACEHOLDER',

        // Buscar tercero
        SEARCH: 'ACCOUNTING.BALANCES.FILTERS.THIRD_PARTY.SEARCH',
      },

      COST_CENTER: {
        // Centro de costos
        LABEL: 'ACCOUNTING.BALANCES.FILTERS.COST_CENTER.LABEL',

        // Se elige del maestro de centros
        TOOLTIP: 'ACCOUNTING.BALANCES.FILTERS.COST_CENTER.TOOLTIP',

        // Codigo
        PLACEHOLDER: 'ACCOUNTING.BALANCES.FILTERS.COST_CENTER.PLACEHOLDER',

        // Buscar centro de costos
        SEARCH: 'ACCOUNTING.BALANCES.FILTERS.COST_CENTER.SEARCH',
      },

      PERIOD: {
        // Periodo
        LABEL: 'ACCOUNTING.BALANCES.FILTERS.PERIOD.LABEL',

        // Periodo contable exacto, en formato aaaaMM
        TOOLTIP: 'ACCOUNTING.BALANCES.FILTERS.PERIOD.TOOLTIP',

        // aaaaMM
        PLACEHOLDER: 'ACCOUNTING.BALANCES.FILTERS.PERIOD.PLACEHOLDER',
      },

      // Filtrar
      APPLY: 'ACCOUNTING.BALANCES.FILTERS.APPLY',

      // Limpiar
      CLEAR: 'ACCOUNTING.BALANCES.FILTERS.CLEAR',
    },

    /** Titulos de los selectores de maestro que abren los filtros. */
    MODAL: {
      // Seleccionar Cuenta Contable
      ACCOUNT: 'ACCOUNTING.BALANCES.MODAL.ACCOUNT',

      // Seleccionar Centro de Costos
      COST_CENTER: 'ACCOUNTING.BALANCES.MODAL.COST_CENTER',
    },

    /**
     * Ejes del cubo. Quitar uno lo saca del corte: las filas se funden y el backend reagrupa.
     *
     * Son las etiquetas de los botones, y no las de las columnas, porque nombran el EJE y no el
     * campo: el eje Cuenta gobierna dos columnas, el codigo y el nombre.
     */
    AXES: {
      // Desglosar por:
      LABEL: 'ACCOUNTING.BALANCES.AXES.LABEL',

      // Tipo de plan
      PLAN_TYPE: 'ACCOUNTING.BALANCES.AXES.PLAN_TYPE',

      // Cuenta
      ACCOUNT: 'ACCOUNTING.BALANCES.AXES.ACCOUNT',

      // Tercero
      THIRD_PARTY: 'ACCOUNTING.BALANCES.AXES.THIRD_PARTY',

      // Centro de costos
      COST_CENTER: 'ACCOUNTING.BALANCES.AXES.COST_CENTER',

      // Periodo
      PERIOD: 'ACCOUNTING.BALANCES.AXES.PERIOD',

      // Ver detalle completo
      SHOW_ALL: 'ACCOUNTING.BALANCES.AXES.SHOW_ALL',
    },

    /** Banda de totales, calculados por la BASE sobre lo que los filtros seleccionan. */
    TOTALS: {
      // Totales del filtro
      TITLE: 'ACCOUNTING.BALANCES.TOTALS.TITLE',

      // Saldo inicial
      INITIAL: 'ACCOUNTING.BALANCES.TOTALS.INITIAL',

      // Debito
      DEBIT: 'ACCOUNTING.BALANCES.TOTALS.DEBIT',

      // Credito
      CREDIT: 'ACCOUNTING.BALANCES.TOTALS.CREDIT',

      // Saldo final
      FINAL: 'ACCOUNTING.BALANCES.TOTALS.FINAL',

      // Inicial y final salen del primer y del ultimo periodo; debito y credito se suman.
      NOTE: 'ACCOUNTING.BALANCES.TOTALS.NOTE',
    },

    /** Formulario de consulta. Todos los campos van bloqueados: la sabana no se edita. */
    FORM: {
      ACCOUNT_CODE: {
        // Cuenta
        LABEL: 'ACCOUNTING.BALANCES.FORM.ACCOUNT_CODE.LABEL',

        // Codigo de la cuenta contable
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.ACCOUNT_CODE.TOOLTIP',
      },

      ACCOUNT_NAME: {
        // Nombre de la cuenta
        LABEL: 'ACCOUNTING.BALANCES.FORM.ACCOUNT_NAME.LABEL',

        // Nombre en el plan de cuentas
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.ACCOUNT_NAME.TOOLTIP',
      },

      PLAN_TYPE: {
        // Tipo de plan
        LABEL: 'ACCOUNTING.BALANCES.FORM.PLAN_TYPE.LABEL',

        // Plan contable al que pertenece la cuenta
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.PLAN_TYPE.TOOLTIP',
      },

      THIRD_PARTY_ID: {
        // Identificacion del tercero
        LABEL: 'ACCOUNTING.BALANCES.FORM.THIRD_PARTY_ID.LABEL',

        // Numero de documento
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.THIRD_PARTY_ID.TOOLTIP',
      },

      THIRD_PARTY: {
        // Tercero
        LABEL: 'ACCOUNTING.BALANCES.FORM.THIRD_PARTY.LABEL',

        // Razon social o nombre completo
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.THIRD_PARTY.TOOLTIP',
      },

      COST_CENTER_CODE: {
        // Centro de costos
        LABEL: 'ACCOUNTING.BALANCES.FORM.COST_CENTER_CODE.LABEL',

        // Codigo del centro de costos
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.COST_CENTER_CODE.TOOLTIP',
      },

      COST_CENTER_NAME: {
        // Nombre del centro de costos
        LABEL: 'ACCOUNTING.BALANCES.FORM.COST_CENTER_NAME.LABEL',
      },

      PERIOD: {
        // Periodo
        LABEL: 'ACCOUNTING.BALANCES.FORM.PERIOD.LABEL',

        // Periodo contable en formato AAAAMM
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.PERIOD.TOOLTIP',
      },

      INITIAL_BALANCE: {
        // Saldo inicial
        LABEL: 'ACCOUNTING.BALANCES.FORM.INITIAL_BALANCE.LABEL',

        // Cierre del periodo anterior de esta misma tupla. Acumula entre periodos
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.INITIAL_BALANCE.TOOLTIP',
      },

      DEBIT: {
        // Debito
        LABEL: 'ACCOUNTING.BALANCES.FORM.DEBIT.LABEL',

        // Debito del periodo
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.DEBIT.TOOLTIP',
      },

      CREDIT: {
        // Credito
        LABEL: 'ACCOUNTING.BALANCES.FORM.CREDIT.LABEL',

        // Credito del periodo
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.CREDIT.TOOLTIP',
      },

      FINAL_BALANCE: {
        // Saldo final
        LABEL: 'ACCOUNTING.BALANCES.FORM.FINAL_BALANCE.LABEL',

        // Saldo inicial + debito - credito. Es el acumulado al cierre del periodo
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.FINAL_BALANCE.TOOLTIP',
      },

      NET: {
        // Movimiento neto
        LABEL: 'ACCOUNTING.BALANCES.FORM.NET.LABEL',

        // Debito - credito: solo el movimiento del periodo, sin el acumulado
        TOOLTIP: 'ACCOUNTING.BALANCES.FORM.NET.TOOLTIP',
      },
    },

    /**
     * Suite de mantenimiento de saldos (HT_CON_012 Mod). Esta pantalla la INVOCA; no la
     * reimplementa. Los avisos nombran lo que la operacion CONSIGUIO, no la intencion.
     */
    MAINTENANCE: {
      // Verificar
      VERIFY: 'ACCOUNTING.BALANCES.MAINTENANCE.VERIFY',

      // Recalcular
      RECALCULATE: 'ACCOUNTING.BALANCES.MAINTENANCE.RECALCULATE',

      // Recrear periodo
      RECREATE_PERIOD: 'ACCOUNTING.BALANCES.MAINTENANCE.RECREATE_PERIOD',

      // Recrear vigencia
      RECREATE_YEAR: 'ACCOUNTING.BALANCES.MAINTENANCE.RECREATE_YEAR',

      // Indique el periodo en el filtro, en formato aaaaMM, antes de recrear
      PERIOD_REQUIRED: 'ACCOUNTING.BALANCES.MAINTENANCE.PERIOD_REQUIRED',

      // Los saldos coinciden con el movimiento aprobado
      VERIFY_OK: 'ACCOUNTING.BALANCES.MAINTENANCE.VERIFY_OK',

      // {{total}} tupla(s) con saldo distinto al movimiento aprobado. Ejecute Recalcular...
      VERIFY_DIFFERENCES: 'ACCOUNTING.BALANCES.MAINTENANCE.VERIFY_DIFFERENCES',

      // Error al verificar los saldos
      VERIFY_ERROR: 'ACCOUNTING.BALANCES.MAINTENANCE.VERIFY_ERROR',

      RECALCULATE_CONFIRM: {
        // Recalcular saldos contables
        TITLE: 'ACCOUNTING.BALANCES.MAINTENANCE.RECALCULATE_CONFIRM.TITLE',

        // Reconstruye los saldos derivando del movimiento aprobado. Actualiza y no elimina.
        MESSAGE: 'ACCOUNTING.BALANCES.MAINTENANCE.RECALCULATE_CONFIRM.MESSAGE',
      },

      // Recalculo terminado: {{tuplas}} tupla(s) en {{periodos}} periodo(s), ...
      RECALCULATE_OK: 'ACCOUNTING.BALANCES.MAINTENANCE.RECALCULATE_OK',

      // Error al recalcular los saldos
      RECALCULATE_ERROR: 'ACCOUNTING.BALANCES.MAINTENANCE.RECALCULATE_ERROR',

      RECREATE_PERIOD_CONFIRM: {
        // Recrear los saldos desde el periodo {{periodo}}
        TITLE: 'ACCOUNTING.BALANCES.MAINTENANCE.RECREATE_PERIOD_CONFIRM.TITLE',

        // ATENCION: BORRA los saldos desde ese periodo y los reconstruye. Respalde antes.
        MESSAGE: 'ACCOUNTING.BALANCES.MAINTENANCE.RECREATE_PERIOD_CONFIRM.MESSAGE',
      },

      RECREATE_YEAR_CONFIRM: {
        // Recrear los saldos de la vigencia {{vigencia}}
        TITLE: 'ACCOUNTING.BALANCES.MAINTENANCE.RECREATE_YEAR_CONFIRM.TITLE',

        // ATENCION: BORRA los saldos de toda la vigencia y los reconstruye desde enero.
        MESSAGE: 'ACCOUNTING.BALANCES.MAINTENANCE.RECREATE_YEAR_CONFIRM.MESSAGE',
      },

      // Recrear
      RECREATE_ACTION: 'ACCOUNTING.BALANCES.MAINTENANCE.RECREATE_ACTION',

      // Recreacion de {{ambito}} terminada ({{resultado}}): {{eliminadas}} fila(s)...
      RECREATE_OK: 'ACCOUNTING.BALANCES.MAINTENANCE.RECREATE_OK',

      // Error al recrear la {{ambito}}
      RECREATE_ERROR: 'ACCOUNTING.BALANCES.MAINTENANCE.RECREATE_ERROR',

      // periodo {{periodo}}
      SCOPE_PERIOD: 'ACCOUNTING.BALANCES.MAINTENANCE.SCOPE_PERIOD',

      // vigencia {{vigencia}}
      SCOPE_YEAR: 'ACCOUNTING.BALANCES.MAINTENANCE.SCOPE_YEAR',
    },

    /** Exportacion: lo que los criterios seleccionan, no la pagina. */
    EXPORT: {
      // No hay datos para exportar
      NO_DATA: 'ACCOUNTING.BALANCES.EXPORT.NO_DATA',

      // El archivo descargado esta vacio
      EMPTY_FILE: 'ACCOUNTING.BALANCES.EXPORT.EMPTY_FILE',

      // Reporte exportado exitosamente en formato {{formato}}
      OK: 'ACCOUNTING.BALANCES.EXPORT.OK',

      // Error al exportar los datos
      ERROR: 'ACCOUNTING.BALANCES.EXPORT.ERROR',

      // Error en exportacion
      ERROR_TITLE: 'ACCOUNTING.BALANCES.EXPORT.ERROR_TITLE',
    },
  },
  // ============================================================
  // DEPENDENCY (Dependencias)
  // ============================================================
  DEPENDENCY: {
    // Títulos
    TITLE: {
      LIST: 'ACCOUNTING.DEPENDENCY.TITLE.LIST',
      CREATE: 'ACCOUNTING.DEPENDENCY.TITLE.CREATE',
      EDIT: 'ACCOUNTING.DEPENDENCY.TITLE.EDIT',
      VIEW: 'ACCOUNTING.DEPENDENCY.TITLE.VIEW',
    },

    // Subtítulos
    SUBTITLE: {
      LIST: 'ACCOUNTING.DEPENDENCY.SUBTITLE.LIST',
      CREATE: 'ACCOUNTING.DEPENDENCY.SUBTITLE.CREATE',
      EDIT: 'ACCOUNTING.DEPENDENCY.SUBTITLE.EDIT',
      VIEW: 'ACCOUNTING.DEPENDENCY.SUBTITLE.VIEW',
    },

    // Formulario
    FORM: {
      CODE: 'ACCOUNTING.DEPENDENCY.FORM.CODE',
      NAME: 'ACCOUNTING.DEPENDENCY.FORM.NAME',
      TOOLTIP: {
        CODE: 'ACCOUNTING.DEPENDENCY.FORM.TOOLTIP.CODE',
        NAME: 'ACCOUNTING.DEPENDENCY.FORM.TOOLTIP.NAME',
        STATUS: 'ACCOUNTING.DEPENDENCY.FORM.TOOLTIP.STATUS',
      },
    },

    // Búsqueda
    SEARCH_PLACEHOLDER: 'ACCOUNTING.DEPENDENCY.SEARCH_PLACEHOLDER',

    // Contador
    SINGULAR: 'ACCOUNTING.DEPENDENCY.SINGULAR',
    PLURAL: 'ACCOUNTING.DEPENDENCY.PLURAL',

    // Empty state
    EMPTY: {
      MESSAGE: 'ACCOUNTING.DEPENDENCY.EMPTY.MESSAGE',
      DESCRIPTION: 'ACCOUNTING.DEPENDENCY.EMPTY.DESCRIPTION',
    },

    // Mensajes
    MESSAGES: {
      EXPORT_SUCCESS: 'ACCOUNTING.DEPENDENCY.MESSAGES.EXPORT_SUCCESS',
      EXPORT_ERROR_EMPTY: 'ACCOUNTING.DEPENDENCY.MESSAGES.EXPORT_ERROR_EMPTY',
      NO_DATA_TO_EXPORT: 'ACCOUNTING.DEPENDENCY.MESSAGES.NO_DATA_TO_EXPORT',
      IMPORT_TITLE: 'ACCOUNTING.DEPENDENCY.MESSAGES.IMPORT_TITLE',
      IMPORT_SUCCESS_TITLE: 'ACCOUNTING.DEPENDENCY.IMPORT.SUCCESS_TITLE',
      IMPORT_SUCCESS: 'MESSAGES.IMPORT_SUCCESS',
      IMPORT_WARNING_TITLE: 'COMMON.IMPORT.WARNING_TITLE',
      IMPORT_WARNING: 'ACCOUNTING.DEPENDENCY.MESSAGES.IMPORT_WARNING',
      IMPORT_INFO_TITLE: 'MESSAGES.IMPORT_INFO_TITLE',
      IMPORT_INFO: 'ACCOUNTING.DEPENDENCY.MESSAGES.IMPORT_INFO',
      IMPORT_ERROR: 'ACCOUNTING.DEPENDENCY.IMPORT.ERROR_GENERIC',
      IMPORT_ERROR_TITLE: 'ACCOUNTING.DEPENDENCY.IMPORT.ERROR_TITLE',
      IMPORT_DIALOG_ERROR: 'ACCOUNTING.DEPENDENCY.IMPORT.ERROR_OPEN_DIALOG',
      DEPENDENCY_ASSOCIATED_ERROR: 'ACCOUNTING.DEPENDENCY.MESSAGES.DEPENDENCY_ASSOCIATED_ERROR',
      DEPENDENCY_ASSOCIATED_TITLE: 'ACCOUNTING.DEPENDENCY.MESSAGES.DEPENDENCY_ASSOCIATED_TITLE',
      DEPENDENCY_ACTIVE_ERROR: 'ACCOUNTING.DEPENDENCY.MESSAGES.DEPENDENCY_ACTIVE_ERROR',
      DEPENDENCY_ACTIVE_TITLE: 'ACCOUNTING.DEPENDENCY.MESSAGES.DEPENDENCY_ACTIVE_TITLE',
    },

    // Validación
    VALIDATION: {
      MAX_LENGTH: 'ACCOUNTING.DEPENDENCY.VALIDATION.MAX_LENGTH',
    },

    // Diálogo de guardado
    SAVE: {
      CONFIRM_TITLE: 'ACCOUNTING.DEPENDENCY.SAVE.CONFIRM_TITLE',
      CONFIRM_MESSAGE: 'ACCOUNTING.DEPENDENCY.SAVE.CONFIRM_MESSAGE',
    },
  },
  CITY: {
    FORM: {
      DEPARTMENT: 'ACCOUNTING.CITY.FORM.DEPARTMENT',
      CITY: 'ACCOUNTING.THIRD_PARTY.FORM.CITY',
      TOOLTIP: {
        DEPARTMENT: 'ACCOUNTING.CITY.FORM.TOOLTIP.DEPARTMENT',
        CITY: 'ACCOUNTING.THIRD_PARTY.FORM.TOOLTIP.CITY',
      },
      PLACEHOLDER: {
        DEPARTMENT: 'ACCOUNTING.CITY.FORM.PLACEHOLDER.DEPARTMENT',
        CITY: 'ACCOUNTING.THIRD_PARTY.FORM.PLACEHOLDER.CITY',
      },
    },
  },
  STATUS: 'COMMON.STATUS',

  ACTIONS: 'COMMON.ACTIONS', // Acciones / Actions
  ACCEPT: 'ACTIONS.ACCEPT', // Aceptar / Accept
  CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel
  CONSULT: 'ACTIONS.CONSULT', // Consultar / Consult
} as const;
